// @ts-nocheck 
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.8.0 (NJsonSchema v11.0.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import {ApiClientConfig} from "app/modules/main/api/ApiClientConfig";
import {AuthorizedApiBase} from "app/modules/main/api/AuthorizedApiBase";import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import moment from 'moment';

export interface ICalendarClient {
    markDatesAsAvailable(id: number, dates: number[] | null): Promise<void>;
    markDatesAsUnavailable(id: number, dates: number[] | null): Promise<void>;
    updateRate(id: number, model: UpdateRateRequest | null): Promise<void>;
    getList(param: DataListGetParamsOfReservationListFilters | null): Promise<DataListResultOfReservationListModel>;
    getTimeLineItems(): Promise<PropertyTimeLineGroup[]>;
    getReservationDetails(id: number): Promise<ReservationModel>;
    confirmReservation(id: number): Promise<void>;
    cancelReservation(id: number, note: string | null): Promise<void>;
    getMonths(id: number, year: number | undefined, month: number | undefined, count: number | undefined): Promise<CalendarMonthGroup[]>;
}

export class CalendarClient extends AuthorizedApiBase implements ICalendarClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    markDatesAsAvailable(id: number, dates: number[] | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/Calendar/MarkDatesAsAvailable/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dates);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkDatesAsAvailable(_response);
        });
    }

    protected processMarkDatesAsAvailable(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    markDatesAsUnavailable(id: number, dates: number[] | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/Calendar/MarkDatesAsUnavailable/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dates);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkDatesAsUnavailable(_response);
        });
    }

    protected processMarkDatesAsUnavailable(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateRate(id: number, model: UpdateRateRequest | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/Calendar/UpdateRate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRate(_response);
        });
    }

    protected processUpdateRate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getList(param: DataListGetParamsOfReservationListFilters | null, signal?: AbortSignal): Promise<DataListResultOfReservationListModel> {
        let url_ = this.baseUrl + "/adminController/Calendar/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataListResultOfReservationListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfReservationListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfReservationListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfReservationListModel>(null as any);
    }

    getTimeLineItems(signal?: AbortSignal): Promise<PropertyTimeLineGroup[]> {
        let url_ = this.baseUrl + "/adminController/Calendar/GetTimeLineItems";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimeLineItems(_response);
        });
    }

    protected processGetTimeLineItems(response: AxiosResponse): Promise<PropertyTimeLineGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyTimeLineGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PropertyTimeLineGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PropertyTimeLineGroup[]>(null as any);
    }

    getReservationDetails(id: number, signal?: AbortSignal): Promise<ReservationModel> {
        let url_ = this.baseUrl + "/adminController/Calendar/GetReservationDetails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReservationDetails(_response);
        });
    }

    protected processGetReservationDetails(response: AxiosResponse): Promise<ReservationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReservationModel.fromJS(resultData200);
            return Promise.resolve<ReservationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReservationModel>(null as any);
    }

    confirmReservation(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/Calendar/ConfirmReservation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmReservation(_response);
        });
    }

    protected processConfirmReservation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    cancelReservation(id: number, note: string | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/Calendar/CancelReservation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(note);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCancelReservation(_response);
        });
    }

    protected processCancelReservation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getMonths(id: number, year: number | undefined, month: number | undefined, count: number | undefined, signal?: AbortSignal): Promise<CalendarMonthGroup[]> {
        let url_ = this.baseUrl + "/adminController/Calendar/GetMonths/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMonths(_response);
        });
    }

    protected processGetMonths(response: AxiosResponse): Promise<CalendarMonthGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarMonthGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CalendarMonthGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalendarMonthGroup[]>(null as any);
    }
}

export interface IIntegrationClient {
    getIntegrationReservationTimeLineGroups(): Promise<IntegrationReservationTimeLineGroup[]>;
    getIntegrationLogs(id: number | undefined): Promise<IntegrationReservationLog[]>;
    remove(reservationId: number | undefined): Promise<void>;
    retryProcessHosttoolsItem(id: number | undefined): Promise<void>;
    getHosttoolsListings(integrationId: number | undefined): Promise<HostToolsListingSummary[]>;
    getHosttoolsListingPropertyOptions(integrationId: number | undefined): Promise<HostToolsPropertyOption[]>;
    linkHosttoolsListing(listingSyncId: number | undefined, propertyId: number | undefined): Promise<void>;
    createPropertyForHosttoolsListing(listingSyncId: number | undefined): Promise<number>;
    setHosttoolsListingIgnore(listingSyncId: number | undefined, ignore: boolean | undefined): Promise<void>;
}

export class IntegrationClient extends AuthorizedApiBase implements IIntegrationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getIntegrationReservationTimeLineGroups(signal?: AbortSignal): Promise<IntegrationReservationTimeLineGroup[]> {
        let url_ = this.baseUrl + "/adminController/Integration/GetIntegrationReservationTimeLineGroups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIntegrationReservationTimeLineGroups(_response);
        });
    }

    protected processGetIntegrationReservationTimeLineGroups(response: AxiosResponse): Promise<IntegrationReservationTimeLineGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntegrationReservationTimeLineGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IntegrationReservationTimeLineGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationReservationTimeLineGroup[]>(null as any);
    }

    getIntegrationLogs(id: number | undefined, signal?: AbortSignal): Promise<IntegrationReservationLog[]> {
        let url_ = this.baseUrl + "/adminController/Integration/GetIntegrationLogs?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIntegrationLogs(_response);
        });
    }

    protected processGetIntegrationLogs(response: AxiosResponse): Promise<IntegrationReservationLog[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntegrationReservationLog.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IntegrationReservationLog[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationReservationLog[]>(null as any);
    }

    remove(reservationId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/Integration/Remove?";
        if (reservationId === null)
            throw new Error("The parameter 'reservationId' cannot be null.");
        else if (reservationId !== undefined)
            url_ += "reservationId=" + encodeURIComponent("" + reservationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemove(_response);
        });
    }

    protected processRemove(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    retryProcessHosttoolsItem(id: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/Integration/RetryProcessHosttoolsItem?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRetryProcessHosttoolsItem(_response);
        });
    }

    protected processRetryProcessHosttoolsItem(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getHosttoolsListings(integrationId: number | undefined, signal?: AbortSignal): Promise<HostToolsListingSummary[]> {
        let url_ = this.baseUrl + "/adminController/Integration/GetHosttoolsListings?";
        if (integrationId === null)
            throw new Error("The parameter 'integrationId' cannot be null.");
        else if (integrationId !== undefined)
            url_ += "integrationId=" + encodeURIComponent("" + integrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHosttoolsListings(_response);
        });
    }

    protected processGetHosttoolsListings(response: AxiosResponse): Promise<HostToolsListingSummary[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HostToolsListingSummary.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HostToolsListingSummary[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HostToolsListingSummary[]>(null as any);
    }

    getHosttoolsListingPropertyOptions(integrationId: number | undefined, signal?: AbortSignal): Promise<HostToolsPropertyOption[]> {
        let url_ = this.baseUrl + "/adminController/Integration/GetHosttoolsListingPropertyOptions?";
        if (integrationId === null)
            throw new Error("The parameter 'integrationId' cannot be null.");
        else if (integrationId !== undefined)
            url_ += "integrationId=" + encodeURIComponent("" + integrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHosttoolsListingPropertyOptions(_response);
        });
    }

    protected processGetHosttoolsListingPropertyOptions(response: AxiosResponse): Promise<HostToolsPropertyOption[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HostToolsPropertyOption.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HostToolsPropertyOption[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HostToolsPropertyOption[]>(null as any);
    }

    linkHosttoolsListing(listingSyncId: number | undefined, propertyId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/Integration/LinkHosttoolsListing?";
        if (listingSyncId === null)
            throw new Error("The parameter 'listingSyncId' cannot be null.");
        else if (listingSyncId !== undefined)
            url_ += "listingSyncId=" + encodeURIComponent("" + listingSyncId) + "&";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLinkHosttoolsListing(_response);
        });
    }

    protected processLinkHosttoolsListing(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    createPropertyForHosttoolsListing(listingSyncId: number | undefined, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/adminController/Integration/CreatePropertyForHosttoolsListing?";
        if (listingSyncId === null)
            throw new Error("The parameter 'listingSyncId' cannot be null.");
        else if (listingSyncId !== undefined)
            url_ += "listingSyncId=" + encodeURIComponent("" + listingSyncId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePropertyForHosttoolsListing(_response);
        });
    }

    protected processCreatePropertyForHosttoolsListing(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    setHosttoolsListingIgnore(listingSyncId: number | undefined, ignore: boolean | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/Integration/SetHosttoolsListingIgnore?";
        if (listingSyncId === null)
            throw new Error("The parameter 'listingSyncId' cannot be null.");
        else if (listingSyncId !== undefined)
            url_ += "listingSyncId=" + encodeURIComponent("" + listingSyncId) + "&";
        if (ignore === null)
            throw new Error("The parameter 'ignore' cannot be null.");
        else if (ignore !== undefined)
            url_ += "ignore=" + encodeURIComponent("" + ignore) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetHosttoolsListingIgnore(_response);
        });
    }

    protected processSetHosttoolsListingIgnore(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IInventoryAssignmentClient {
    getList(param: DataListGetParamsOfInventoryAssignmentListFilters | null): Promise<DataListResultOfInventoryAssignmentListModel>;
    createInventoryAssignment(model: InventoryAssignmentNewModel | null): Promise<number>;
    updateInventoryAssignment(model: InventoryAssignmentEditModel | null): Promise<void>;
    getDetails(id: number | undefined): Promise<InventoryAssignmentDetailsModel>;
}

export class InventoryAssignmentClient extends AuthorizedApiBase implements IInventoryAssignmentClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(param: DataListGetParamsOfInventoryAssignmentListFilters | null, signal?: AbortSignal): Promise<DataListResultOfInventoryAssignmentListModel> {
        let url_ = this.baseUrl + "/adminController/InventoryAssignment/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataListResultOfInventoryAssignmentListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfInventoryAssignmentListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfInventoryAssignmentListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfInventoryAssignmentListModel>(null as any);
    }

    createInventoryAssignment(model: InventoryAssignmentNewModel | null, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/adminController/InventoryAssignment/CreateInventoryAssignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateInventoryAssignment(_response);
        });
    }

    protected processCreateInventoryAssignment(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    updateInventoryAssignment(model: InventoryAssignmentEditModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/InventoryAssignment/UpdateInventoryAssignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateInventoryAssignment(_response);
        });
    }

    protected processUpdateInventoryAssignment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getDetails(id: number | undefined, signal?: AbortSignal): Promise<InventoryAssignmentDetailsModel> {
        let url_ = this.baseUrl + "/adminController/InventoryAssignment/GetDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetails(_response);
        });
    }

    protected processGetDetails(response: AxiosResponse): Promise<InventoryAssignmentDetailsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InventoryAssignmentDetailsModel.fromJS(resultData200);
            return Promise.resolve<InventoryAssignmentDetailsModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InventoryAssignmentDetailsModel>(null as any);
    }
}

export interface IInventoryClient {
    getList(param: DataListGetParamsOfInventoryItemListFilters | null): Promise<DataListResultOfInventoryItemListModel>;
    getShortList(): Promise<NamedValueLong[]>;
    getDetails(id: number | undefined): Promise<InventoryItemDetailsModel>;
    createInventoryItem(model: InventoryItemNewModel | null): Promise<number>;
    updateInventoryItem(model: InventoryItemEditModel | null): Promise<void>;
    updateStock(model: InventoryItemUpdateStockModel | null): Promise<void>;
}

export class InventoryClient extends AuthorizedApiBase implements IInventoryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(param: DataListGetParamsOfInventoryItemListFilters | null, signal?: AbortSignal): Promise<DataListResultOfInventoryItemListModel> {
        let url_ = this.baseUrl + "/adminController/Inventory/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataListResultOfInventoryItemListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfInventoryItemListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfInventoryItemListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfInventoryItemListModel>(null as any);
    }

    getShortList(signal?: AbortSignal): Promise<NamedValueLong[]> {
        let url_ = this.baseUrl + "/adminController/Inventory/GetShortList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShortList(_response);
        });
    }

    protected processGetShortList(response: AxiosResponse): Promise<NamedValueLong[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NamedValueLong.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<NamedValueLong[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NamedValueLong[]>(null as any);
    }

    getDetails(id: number | undefined, signal?: AbortSignal): Promise<InventoryItemDetailsModel> {
        let url_ = this.baseUrl + "/adminController/Inventory/GetDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetails(_response);
        });
    }

    protected processGetDetails(response: AxiosResponse): Promise<InventoryItemDetailsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InventoryItemDetailsModel.fromJS(resultData200);
            return Promise.resolve<InventoryItemDetailsModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InventoryItemDetailsModel>(null as any);
    }

    createInventoryItem(model: InventoryItemNewModel | null, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/adminController/Inventory/CreateInventoryItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateInventoryItem(_response);
        });
    }

    protected processCreateInventoryItem(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    updateInventoryItem(model: InventoryItemEditModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/Inventory/UpdateInventoryItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateInventoryItem(_response);
        });
    }

    protected processUpdateInventoryItem(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateStock(model: InventoryItemUpdateStockModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/Inventory/UpdateStock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStock(_response);
        });
    }

    protected processUpdateStock(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IPolicyClient {
    upsertPolicy(param: PolicyEditModel | null): Promise<number>;
    getList(param: DataListGetParamsOfPolicyListFilters | null): Promise<DataListResultOfPolicyListModel>;
    getShortList(param: PolicyShortListFilters | null): Promise<PolicyShortListModel[]>;
    getDetails(id: number): Promise<PolicyModel>;
    /**
     * @return or

    or

    or

    or
     */
    types(): Promise<any>;
    getPolicyString(model: PolicyStringPreviewModel | null): Promise<string>;
}

export class PolicyClient extends AuthorizedApiBase implements IPolicyClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    upsertPolicy(param: PolicyEditModel | null, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/adminController/Policy/UpsertPolicy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertPolicy(_response);
        });
    }

    protected processUpsertPolicy(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getList(param: DataListGetParamsOfPolicyListFilters | null, signal?: AbortSignal): Promise<DataListResultOfPolicyListModel> {
        let url_ = this.baseUrl + "/adminController/Policy/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataListResultOfPolicyListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfPolicyListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfPolicyListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfPolicyListModel>(null as any);
    }

    getShortList(param: PolicyShortListFilters | null, signal?: AbortSignal): Promise<PolicyShortListModel[]> {
        let url_ = this.baseUrl + "/adminController/Policy/GetShortList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShortList(_response);
        });
    }

    protected processGetShortList(response: AxiosResponse): Promise<PolicyShortListModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PolicyShortListModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PolicyShortListModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PolicyShortListModel[]>(null as any);
    }

    getDetails(id: number, signal?: AbortSignal): Promise<PolicyModel> {
        let url_ = this.baseUrl + "/adminController/Policy/GetDetails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetails(_response);
        });
    }

    protected processGetDetails(response: AxiosResponse): Promise<PolicyModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PolicyModel.fromJS(resultData200);
            return Promise.resolve<PolicyModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PolicyModel>(null as any);
    }

    /**
     * @return or

    or

    or

    or
     */
    types(signal?: AbortSignal): Promise<any> {
        let url_ = this.baseUrl + "/adminController/Policy/Types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTypes(_response);
        });
    }

    protected processTypes(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    getPolicyString(model: PolicyStringPreviewModel | null, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/adminController/Policy/GetPolicyString";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPolicyString(_response);
        });
    }

    protected processGetPolicyString(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IPropertyAmenityClient {
    upsertPropertyAmenity(param: PropertyAmenityEditModel | null): Promise<number>;
    getList(param: DataListGetParamsOfPropertyAmenityListFilters | null): Promise<DataListResultOfPropertyAmenityListModel>;
    getShortList(): Promise<PropertyAmenityShortListModel[]>;
    getDetails(id: number): Promise<PropertyAmenityModel>;
}

export class PropertyAmenityClient extends AuthorizedApiBase implements IPropertyAmenityClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    upsertPropertyAmenity(param: PropertyAmenityEditModel | null, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/adminController/PropertyAmenity/UpsertPropertyAmenity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertPropertyAmenity(_response);
        });
    }

    protected processUpsertPropertyAmenity(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getList(param: DataListGetParamsOfPropertyAmenityListFilters | null, signal?: AbortSignal): Promise<DataListResultOfPropertyAmenityListModel> {
        let url_ = this.baseUrl + "/adminController/PropertyAmenity/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataListResultOfPropertyAmenityListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfPropertyAmenityListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfPropertyAmenityListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfPropertyAmenityListModel>(null as any);
    }

    getShortList(signal?: AbortSignal): Promise<PropertyAmenityShortListModel[]> {
        let url_ = this.baseUrl + "/adminController/PropertyAmenity/GetShortList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShortList(_response);
        });
    }

    protected processGetShortList(response: AxiosResponse): Promise<PropertyAmenityShortListModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyAmenityShortListModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PropertyAmenityShortListModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PropertyAmenityShortListModel[]>(null as any);
    }

    getDetails(id: number, signal?: AbortSignal): Promise<PropertyAmenityModel> {
        let url_ = this.baseUrl + "/adminController/PropertyAmenity/GetDetails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetails(_response);
        });
    }

    protected processGetDetails(response: AxiosResponse): Promise<PropertyAmenityModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PropertyAmenityModel.fromJS(resultData200);
            return Promise.resolve<PropertyAmenityModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PropertyAmenityModel>(null as any);
    }
}

export interface IPropertyContactClient {
    upsertPropertyContact(param: PropertyContactEditModel | null): Promise<number>;
    getList(param: DataListGetParamsOfPropertyContactListFilters | null): Promise<DataListResultOfPropertyContactListModel>;
    getShortList(): Promise<PropertyContactShortListModel[]>;
    getDetails(id: number): Promise<PropertyContactModel>;
}

export class PropertyContactClient extends AuthorizedApiBase implements IPropertyContactClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    upsertPropertyContact(param: PropertyContactEditModel | null, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/adminController/PropertyContact/UpsertPropertyContact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertPropertyContact(_response);
        });
    }

    protected processUpsertPropertyContact(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getList(param: DataListGetParamsOfPropertyContactListFilters | null, signal?: AbortSignal): Promise<DataListResultOfPropertyContactListModel> {
        let url_ = this.baseUrl + "/adminController/PropertyContact/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataListResultOfPropertyContactListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfPropertyContactListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfPropertyContactListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfPropertyContactListModel>(null as any);
    }

    getShortList(signal?: AbortSignal): Promise<PropertyContactShortListModel[]> {
        let url_ = this.baseUrl + "/adminController/PropertyContact/GetShortList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShortList(_response);
        });
    }

    protected processGetShortList(response: AxiosResponse): Promise<PropertyContactShortListModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyContactShortListModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PropertyContactShortListModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PropertyContactShortListModel[]>(null as any);
    }

    getDetails(id: number, signal?: AbortSignal): Promise<PropertyContactModel> {
        let url_ = this.baseUrl + "/adminController/PropertyContact/GetDetails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetails(_response);
        });
    }

    protected processGetDetails(response: AxiosResponse): Promise<PropertyContactModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PropertyContactModel.fromJS(resultData200);
            return Promise.resolve<PropertyContactModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PropertyContactModel>(null as any);
    }
}

export interface IPropertyClient {
    getProperty(id: number): Promise<PropertyDetails>;
    getList(param: DataListGetParamsOfPropertyListFilters | null): Promise<DataListResultOfPropertyListModel>;
    getShortList(param: PropertyListFilters | null): Promise<PropertyShortListModel[]>;
    getShortDetails(id: number): Promise<PropertyShortDetailsModel>;
    upsertProperty(model: PropertyEdit | null): Promise<number>;
    upload(propertyId: number | undefined, contentType: string | null | undefined, contentDisposition: string | null | undefined, headers: any[] | null | undefined, length: number | undefined, name: string | null | undefined, fileName: string | null | undefined): Promise<void>;
    uploadByType(propertyId: number | undefined, type: PropertyAdditionalImageType | undefined, contentType: string | null | undefined, contentDisposition: string | null | undefined, headers: any[] | null | undefined, length: number | undefined, name: string | null | undefined, fileName: string | null | undefined): Promise<void>;
    getFileWithParams(path: string | null | undefined, sizeMap: number | undefined, quality: number | undefined, format: SKEncodedImageFormat | undefined): Promise<FileResponse>;
    getFile(path: string | null | undefined): Promise<FileResponse>;
    deletePropertyImage(id: number | undefined, imageId: number | undefined): Promise<void>;
    deletePropertyAdditionalImage(id: number | undefined, imageId: number | undefined, type: PropertyAdditionalImageType | undefined): Promise<void>;
    getImages(id: number | undefined): Promise<PropertyImage[]>;
    getAdditionalImages(id: number | undefined, type: PropertyAdditionalImageType | undefined): Promise<PropertyAdditionalImage[]>;
    makeThumbnail(id: number | undefined, imageId: number | undefined): Promise<void>;
    delist(id: number | undefined): Promise<void>;
    list(id: number | undefined): Promise<void>;
    setDefaultPrice(id: number | undefined, rate: number | undefined): Promise<void>;
    getRateList(propertyId: number | undefined): Promise<RateListModel[]>;
    upsertPropertyRate(propertyId: number | undefined, model: RateEditModel | null): Promise<number>;
    /**
     * @return or

    or

    or

    or

    or

    or
     */
    types(): Promise<any>;
    deletePropertyRate(propertyId: number | undefined, rateId: number | undefined): Promise<void>;
    getPreviewRates(id: number, nights: number | undefined, guests: number | undefined, pets: number | undefined, promoCode: string | null | undefined): Promise<BookRatesDetails>;
    getIntegrations(): Promise<IntegrationModel[]>;
    getHostawayListings(hostawayIntegrationId: number | undefined): Promise<ListingListModel[]>;
    getPropertyIntegrations(id: number): Promise<PropertyIntegrationModel[]>;
    updateIntegrations(id: number, integrations: PropertyIntegrationModel[] | null): Promise<void>;
    getPropertyInstructionParams(): Promise<string[]>;
}

export class PropertyClient extends AuthorizedApiBase implements IPropertyClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getProperty(id: number, signal?: AbortSignal): Promise<PropertyDetails> {
        let url_ = this.baseUrl + "/adminController/Property/GetProperty/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProperty(_response);
        });
    }

    protected processGetProperty(response: AxiosResponse): Promise<PropertyDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PropertyDetails.fromJS(resultData200);
            return Promise.resolve<PropertyDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PropertyDetails>(null as any);
    }

    getList(param: DataListGetParamsOfPropertyListFilters | null, signal?: AbortSignal): Promise<DataListResultOfPropertyListModel> {
        let url_ = this.baseUrl + "/adminController/Property/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataListResultOfPropertyListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfPropertyListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfPropertyListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfPropertyListModel>(null as any);
    }

    getShortList(param: PropertyListFilters | null, signal?: AbortSignal): Promise<PropertyShortListModel[]> {
        let url_ = this.baseUrl + "/adminController/Property/GetShortList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShortList(_response);
        });
    }

    protected processGetShortList(response: AxiosResponse): Promise<PropertyShortListModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyShortListModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PropertyShortListModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PropertyShortListModel[]>(null as any);
    }

    getShortDetails(id: number, signal?: AbortSignal): Promise<PropertyShortDetailsModel> {
        let url_ = this.baseUrl + "/adminController/Property/GetShortDetails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShortDetails(_response);
        });
    }

    protected processGetShortDetails(response: AxiosResponse): Promise<PropertyShortDetailsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PropertyShortDetailsModel.fromJS(resultData200);
            return Promise.resolve<PropertyShortDetailsModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PropertyShortDetailsModel>(null as any);
    }

    upsertProperty(model: PropertyEdit | null, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/adminController/Property/UpsertProperty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertProperty(_response);
        });
    }

    protected processUpsertProperty(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    upload(propertyId: number | undefined, contentType: string | null | undefined, contentDisposition: string | null | undefined, headers: any[] | null | undefined, length: number | undefined, name: string | null | undefined, fileName: string | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/Property/Upload?";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (contentDisposition !== null && contentDisposition !== undefined)
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers !== null && headers !== undefined)
            headers.forEach(item_ => content_.append("Headers", item_.toString()));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpload(_response);
        });
    }

    protected processUpload(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    uploadByType(propertyId: number | undefined, type: PropertyAdditionalImageType | undefined, contentType: string | null | undefined, contentDisposition: string | null | undefined, headers: any[] | null | undefined, length: number | undefined, name: string | null | undefined, fileName: string | null | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/Property/UploadByType?";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (contentDisposition !== null && contentDisposition !== undefined)
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers !== null && headers !== undefined)
            headers.forEach(item_ => content_.append("Headers", item_.toString()));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadByType(_response);
        });
    }

    protected processUploadByType(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getFileWithParams(path: string | null | undefined, sizeMap: number | undefined, quality: number | undefined, format: SKEncodedImageFormat | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/adminController/Property/GetFileWithParams?";
        if (path !== undefined && path !== null)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        if (sizeMap === null)
            throw new Error("The parameter 'sizeMap' cannot be null.");
        else if (sizeMap !== undefined)
            url_ += "sizeMap=" + encodeURIComponent("" + sizeMap) + "&";
        if (quality === null)
            throw new Error("The parameter 'quality' cannot be null.");
        else if (quality !== undefined)
            url_ += "quality=" + encodeURIComponent("" + quality) + "&";
        if (format === null)
            throw new Error("The parameter 'format' cannot be null.");
        else if (format !== undefined)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFileWithParams(_response);
        });
    }

    protected processGetFileWithParams(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getFile(path: string | null | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/adminController/Property/GetFile?";
        if (path !== undefined && path !== null)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFile(_response);
        });
    }

    protected processGetFile(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deletePropertyImage(id: number | undefined, imageId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/Property/DeletePropertyImage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (imageId === null)
            throw new Error("The parameter 'imageId' cannot be null.");
        else if (imageId !== undefined)
            url_ += "imageId=" + encodeURIComponent("" + imageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePropertyImage(_response);
        });
    }

    protected processDeletePropertyImage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deletePropertyAdditionalImage(id: number | undefined, imageId: number | undefined, type: PropertyAdditionalImageType | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/Property/DeletePropertyAdditionalImage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (imageId === null)
            throw new Error("The parameter 'imageId' cannot be null.");
        else if (imageId !== undefined)
            url_ += "imageId=" + encodeURIComponent("" + imageId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePropertyAdditionalImage(_response);
        });
    }

    protected processDeletePropertyAdditionalImage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getImages(id: number | undefined, signal?: AbortSignal): Promise<PropertyImage[]> {
        let url_ = this.baseUrl + "/adminController/Property/GetImages?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetImages(_response);
        });
    }

    protected processGetImages(response: AxiosResponse): Promise<PropertyImage[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyImage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PropertyImage[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PropertyImage[]>(null as any);
    }

    getAdditionalImages(id: number | undefined, type: PropertyAdditionalImageType | undefined, signal?: AbortSignal): Promise<PropertyAdditionalImage[]> {
        let url_ = this.baseUrl + "/adminController/Property/GetAdditionalImages?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdditionalImages(_response);
        });
    }

    protected processGetAdditionalImages(response: AxiosResponse): Promise<PropertyAdditionalImage[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyAdditionalImage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PropertyAdditionalImage[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PropertyAdditionalImage[]>(null as any);
    }

    makeThumbnail(id: number | undefined, imageId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/Property/MakeThumbnail?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (imageId === null)
            throw new Error("The parameter 'imageId' cannot be null.");
        else if (imageId !== undefined)
            url_ += "imageId=" + encodeURIComponent("" + imageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMakeThumbnail(_response);
        });
    }

    protected processMakeThumbnail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    delist(id: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/Property/Delist?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelist(_response);
        });
    }

    protected processDelist(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    list(id: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/Property/List?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    setDefaultPrice(id: number | undefined, rate: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/Property/SetDefaultPrice?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (rate === null)
            throw new Error("The parameter 'rate' cannot be null.");
        else if (rate !== undefined)
            url_ += "rate=" + encodeURIComponent("" + rate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetDefaultPrice(_response);
        });
    }

    protected processSetDefaultPrice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getRateList(propertyId: number | undefined, signal?: AbortSignal): Promise<RateListModel[]> {
        let url_ = this.baseUrl + "/adminController/Property/GetRateList?";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRateList(_response);
        });
    }

    protected processGetRateList(response: AxiosResponse): Promise<RateListModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RateListModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RateListModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RateListModel[]>(null as any);
    }

    upsertPropertyRate(propertyId: number | undefined, model: RateEditModel | null, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/adminController/Property/UpsertPropertyRate?";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsertPropertyRate(_response);
        });
    }

    protected processUpsertPropertyRate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @return or

    or

    or

    or

    or

    or
     */
    types(signal?: AbortSignal): Promise<any> {
        let url_ = this.baseUrl + "/adminController/Property/Types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTypes(_response);
        });
    }

    protected processTypes(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    deletePropertyRate(propertyId: number | undefined, rateId: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/Property/DeletePropertyRate?";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        if (rateId === null)
            throw new Error("The parameter 'rateId' cannot be null.");
        else if (rateId !== undefined)
            url_ += "rateId=" + encodeURIComponent("" + rateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePropertyRate(_response);
        });
    }

    protected processDeletePropertyRate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getPreviewRates(id: number, nights: number | undefined, guests: number | undefined, pets: number | undefined, promoCode: string | null | undefined, signal?: AbortSignal): Promise<BookRatesDetails> {
        let url_ = this.baseUrl + "/adminController/Property/GetPreviewRates/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (nights === null)
            throw new Error("The parameter 'nights' cannot be null.");
        else if (nights !== undefined)
            url_ += "nights=" + encodeURIComponent("" + nights) + "&";
        if (guests === null)
            throw new Error("The parameter 'guests' cannot be null.");
        else if (guests !== undefined)
            url_ += "guests=" + encodeURIComponent("" + guests) + "&";
        if (pets === null)
            throw new Error("The parameter 'pets' cannot be null.");
        else if (pets !== undefined)
            url_ += "pets=" + encodeURIComponent("" + pets) + "&";
        if (promoCode !== undefined && promoCode !== null)
            url_ += "promoCode=" + encodeURIComponent("" + promoCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPreviewRates(_response);
        });
    }

    protected processGetPreviewRates(response: AxiosResponse): Promise<BookRatesDetails> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BookRatesDetails.fromJS(resultData200);
            return Promise.resolve<BookRatesDetails>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BookRatesDetails>(null as any);
    }

    getIntegrations(signal?: AbortSignal): Promise<IntegrationModel[]> {
        let url_ = this.baseUrl + "/adminController/Property/GetIntegrations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIntegrations(_response);
        });
    }

    protected processGetIntegrations(response: AxiosResponse): Promise<IntegrationModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntegrationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<IntegrationModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IntegrationModel[]>(null as any);
    }

    getHostawayListings(hostawayIntegrationId: number | undefined, signal?: AbortSignal): Promise<ListingListModel[]> {
        let url_ = this.baseUrl + "/adminController/Property/GetHostawayListings?";
        if (hostawayIntegrationId === null)
            throw new Error("The parameter 'hostawayIntegrationId' cannot be null.");
        else if (hostawayIntegrationId !== undefined)
            url_ += "hostawayIntegrationId=" + encodeURIComponent("" + hostawayIntegrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHostawayListings(_response);
        });
    }

    protected processGetHostawayListings(response: AxiosResponse): Promise<ListingListModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListingListModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ListingListModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListingListModel[]>(null as any);
    }

    getPropertyIntegrations(id: number, signal?: AbortSignal): Promise<PropertyIntegrationModel[]> {
        let url_ = this.baseUrl + "/adminController/Property/GetPropertyIntegrations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPropertyIntegrations(_response);
        });
    }

    protected processGetPropertyIntegrations(response: AxiosResponse): Promise<PropertyIntegrationModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyIntegrationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PropertyIntegrationModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PropertyIntegrationModel[]>(null as any);
    }

    updateIntegrations(id: number, integrations: PropertyIntegrationModel[] | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/Property/UpdateIntegrations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(integrations);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateIntegrations(_response);
        });
    }

    protected processUpdateIntegrations(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getPropertyInstructionParams(signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/adminController/Property/GetPropertyInstructionParams";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPropertyInstructionParams(_response);
        });
    }

    protected processGetPropertyInstructionParams(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export interface IPropertyInventoryClient {
    getList(param: DataListGetParamsOfPropertyInventoryListFilters | null): Promise<DataListResultOfPropertyInventoryListModel>;
    getListByPropertyId(propertyId: number | undefined): Promise<PropertyInventoryListModel[]>;
    overrideRequiredQty(model: PropertyInventoryUpdatedRequiredQtyModel | null): Promise<void>;
    resetRequiredQty(model: PropertyInventoryResetRequiredQtyModel | null): Promise<void>;
    updateStock(model: PropertyInventoryUpdateStockModel | null): Promise<void>;
    stocktaking(models: PropertyInventoryStocktaking[] | null): Promise<void>;
    replace(id: number | undefined): Promise<void>;
    addItem(model: PropertyInventoryNewModel | null): Promise<void>;
    addItems(model: PropertyInventoryAddAllModel | null): Promise<void>;
    addInventoryAssignment(model: PropertyInventoryAddAssignmentModel | null): Promise<void>;
    getDetails(id: number | undefined): Promise<PropertyInventoryDetailsModel>;
}

export class PropertyInventoryClient extends AuthorizedApiBase implements IPropertyInventoryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    getList(param: DataListGetParamsOfPropertyInventoryListFilters | null, signal?: AbortSignal): Promise<DataListResultOfPropertyInventoryListModel> {
        let url_ = this.baseUrl + "/adminController/PropertyInventory/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataListResultOfPropertyInventoryListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfPropertyInventoryListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfPropertyInventoryListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfPropertyInventoryListModel>(null as any);
    }

    getListByPropertyId(propertyId: number | undefined, signal?: AbortSignal): Promise<PropertyInventoryListModel[]> {
        let url_ = this.baseUrl + "/adminController/PropertyInventory/GetListByPropertyId?";
        if (propertyId === null)
            throw new Error("The parameter 'propertyId' cannot be null.");
        else if (propertyId !== undefined)
            url_ += "propertyId=" + encodeURIComponent("" + propertyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListByPropertyId(_response);
        });
    }

    protected processGetListByPropertyId(response: AxiosResponse): Promise<PropertyInventoryListModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PropertyInventoryListModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PropertyInventoryListModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PropertyInventoryListModel[]>(null as any);
    }

    overrideRequiredQty(model: PropertyInventoryUpdatedRequiredQtyModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/PropertyInventory/OverrideRequiredQty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOverrideRequiredQty(_response);
        });
    }

    protected processOverrideRequiredQty(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    resetRequiredQty(model: PropertyInventoryResetRequiredQtyModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/PropertyInventory/ResetRequiredQty";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetRequiredQty(_response);
        });
    }

    protected processResetRequiredQty(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    updateStock(model: PropertyInventoryUpdateStockModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/PropertyInventory/UpdateStock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStock(_response);
        });
    }

    protected processUpdateStock(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    stocktaking(models: PropertyInventoryStocktaking[] | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/PropertyInventory/Stocktaking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(models);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStocktaking(_response);
        });
    }

    protected processStocktaking(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    replace(id: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/PropertyInventory/Replace?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReplace(_response);
        });
    }

    protected processReplace(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addItem(model: PropertyInventoryNewModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/PropertyInventory/AddItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddItem(_response);
        });
    }

    protected processAddItem(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addItems(model: PropertyInventoryAddAllModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/PropertyInventory/AddItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddItems(_response);
        });
    }

    protected processAddItems(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    addInventoryAssignment(model: PropertyInventoryAddAssignmentModel | null, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/PropertyInventory/AddInventoryAssignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddInventoryAssignment(_response);
        });
    }

    protected processAddInventoryAssignment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getDetails(id: number | undefined, signal?: AbortSignal): Promise<PropertyInventoryDetailsModel> {
        let url_ = this.baseUrl + "/adminController/PropertyInventory/GetDetails?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetails(_response);
        });
    }

    protected processGetDetails(response: AxiosResponse): Promise<PropertyInventoryDetailsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PropertyInventoryDetailsModel.fromJS(resultData200);
            return Promise.resolve<PropertyInventoryDetailsModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PropertyInventoryDetailsModel>(null as any);
    }
}

export interface IPropertyPromoCodeClient {
    createPropertyPromoCode(model: PropertyPromoCodeEditModel | null): Promise<number>;
    getList(param: DataListGetParamsOfPropertyPromoCodeListFilters | null): Promise<DataListResultOfPropertyPromoCodeListModel>;
    deactivate(id: number): Promise<void>;
    getDetails(id: number): Promise<PropertyPromoCodeModel>;
}

export class PropertyPromoCodeClient extends AuthorizedApiBase implements IPropertyPromoCodeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    createPropertyPromoCode(model: PropertyPromoCodeEditModel | null, signal?: AbortSignal): Promise<number> {
        let url_ = this.baseUrl + "/adminController/PropertyPromoCode/CreatePropertyPromoCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePropertyPromoCode(_response);
        });
    }

    protected processCreatePropertyPromoCode(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getList(param: DataListGetParamsOfPropertyPromoCodeListFilters | null, signal?: AbortSignal): Promise<DataListResultOfPropertyPromoCodeListModel> {
        let url_ = this.baseUrl + "/adminController/PropertyPromoCode/GetList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(param);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<DataListResultOfPropertyPromoCodeListModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DataListResultOfPropertyPromoCodeListModel.fromJS(resultData200);
            return Promise.resolve<DataListResultOfPropertyPromoCodeListModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DataListResultOfPropertyPromoCodeListModel>(null as any);
    }

    deactivate(id: number, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/PropertyPromoCode/Deactivate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeactivate(_response);
        });
    }

    protected processDeactivate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getDetails(id: number, signal?: AbortSignal): Promise<PropertyPromoCodeModel> {
        let url_ = this.baseUrl + "/adminController/PropertyPromoCode/GetDetails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDetails(_response);
        });
    }

    protected processGetDetails(response: AxiosResponse): Promise<PropertyPromoCodeModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PropertyPromoCodeModel.fromJS(resultData200);
            return Promise.resolve<PropertyPromoCodeModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PropertyPromoCodeModel>(null as any);
    }
}

export interface IToolsClient {
    resetjobs(): Promise<void>;
    getQRCode(reference: string | null | undefined): Promise<FileResponse>;
    processWebhook(id: number | undefined): Promise<void>;
}

export class ToolsClient extends AuthorizedApiBase implements IToolsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ApiClientConfig, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("");

    }

    resetjobs(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/Tools/Resetjobs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetjobs(_response);
        });
    }

    protected processResetjobs(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getQRCode(reference: string | null | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/adminController/Tools/GetQRCode?";
        if (reference !== undefined && reference !== null)
            url_ += "reference=" + encodeURIComponent("" + reference) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetQRCode(_response);
        });
    }

    protected processGetQRCode(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    processWebhook(id: number | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/adminController/Tools/ProcessWebhook?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProcessWebhook(_response);
        });
    }

    protected processProcessWebhook(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UpdateRateRequest implements IUpdateRateRequest {
    dates?: number[] | undefined;
    rate?: number | undefined;
    discountRate?: number | undefined;

    constructor(data?: IUpdateRateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Dates"])) {
                this.dates = [] as any;
                for (let item of _data["Dates"])
                    this.dates!.push(item);
            }
            this.rate = _data["Rate"];
            this.discountRate = _data["DiscountRate"];
        }
    }

    static fromJS(data: any): UpdateRateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dates)) {
            data["Dates"] = [];
            for (let item of this.dates)
                data["Dates"].push(item);
        }
        data["Rate"] = this.rate;
        data["DiscountRate"] = this.discountRate;
        return data;
    }

    clone(): UpdateRateRequest {
        const json = this.toJSON();
        let result = new UpdateRateRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateRateRequest {
    dates?: number[] | undefined;
    rate?: number | undefined;
    discountRate?: number | undefined;
}

export class DataListResultOfReservationListModel implements IDataListResultOfReservationListModel {
    items?: ReservationListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfReservationListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(ReservationListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfReservationListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfReservationListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfReservationListModel {
        const json = this.toJSON();
        let result = new DataListResultOfReservationListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfReservationListModel {
    items?: ReservationListModel[] | undefined;
    count?: number;
}

export class ReservationListModel implements IReservationListModel {
    id?: number;
    name?: string | undefined;
    guestName?: string | undefined;
    nights?: number;
    from?: moment.Moment;
    to?: moment.Moment;
    total?: number;
    status?: PropertyReservationStatus;
    createdAt?: moment.Moment | undefined;
    reservationCode?: string | undefined;
    paymentStatus?: GetReservationCompletionInfoModelStatus | undefined;

    constructor(data?: IReservationListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.guestName = _data["GuestName"];
            this.nights = _data["Nights"];
            this.from = _data["From"] ? moment(_data["From"].toString()) : <any>undefined;
            this.to = _data["To"] ? moment(_data["To"].toString()) : <any>undefined;
            this.total = _data["Total"];
            this.status = _data["Status"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.reservationCode = _data["ReservationCode"];
            this.paymentStatus = _data["PaymentStatus"];
        }
    }

    static fromJS(data: any): ReservationListModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["GuestName"] = this.guestName;
        data["Nights"] = this.nights;
        data["From"] = this.from ? this.from.toISOString() : <any>undefined;
        data["To"] = this.to ? this.to.toISOString() : <any>undefined;
        data["Total"] = this.total;
        data["Status"] = this.status;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["ReservationCode"] = this.reservationCode;
        data["PaymentStatus"] = this.paymentStatus;
        return data;
    }

    clone(): ReservationListModel {
        const json = this.toJSON();
        let result = new ReservationListModel();
        result.init(json);
        return result;
    }
}

export interface IReservationListModel {
    id?: number;
    name?: string | undefined;
    guestName?: string | undefined;
    nights?: number;
    from?: moment.Moment;
    to?: moment.Moment;
    total?: number;
    status?: PropertyReservationStatus;
    createdAt?: moment.Moment | undefined;
    reservationCode?: string | undefined;
    paymentStatus?: GetReservationCompletionInfoModelStatus | undefined;
}

/** 1 = Requested 2 = Confirmed 3 = Cancelled */
export enum PropertyReservationStatus {
    Requested = 1,
    Confirmed = 2,
    Cancelled = 3,
}

/** 1 = Failed 2 = Pending 3 = Success */
export enum GetReservationCompletionInfoModelStatus {
    Failed = 1,
    Pending = 2,
    Success = 3,
}

export class DataListGetParamsOfReservationListFilters implements IDataListGetParamsOfReservationListFilters {
    filter?: ReservationListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfReservationListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? ReservationListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfReservationListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfReservationListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfReservationListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfReservationListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfReservationListFilters {
    filter?: ReservationListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class ReservationListFilters implements IReservationListFilters {
    search?: string | undefined;

    constructor(data?: IReservationListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
        }
    }

    static fromJS(data: any): ReservationListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        return data;
    }

    clone(): ReservationListFilters {
        const json = this.toJSON();
        let result = new ReservationListFilters();
        result.init(json);
        return result;
    }
}

export interface IReservationListFilters {
    search?: string | undefined;
}

export class PropertyTimeLineGroup implements IPropertyTimeLineGroup {
    id?: number;
    name?: string | undefined;
    total?: number;
    reservations?: PropertyTimeLineReservation[] | undefined;

    constructor(data?: IPropertyTimeLineGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.total = _data["Total"];
            if (Array.isArray(_data["Reservations"])) {
                this.reservations = [] as any;
                for (let item of _data["Reservations"])
                    this.reservations!.push(PropertyTimeLineReservation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertyTimeLineGroup {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyTimeLineGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Total"] = this.total;
        if (Array.isArray(this.reservations)) {
            data["Reservations"] = [];
            for (let item of this.reservations)
                data["Reservations"].push(item.toJSON());
        }
        return data;
    }

    clone(): PropertyTimeLineGroup {
        const json = this.toJSON();
        let result = new PropertyTimeLineGroup();
        result.init(json);
        return result;
    }
}

export interface IPropertyTimeLineGroup {
    id?: number;
    name?: string | undefined;
    total?: number;
    reservations?: PropertyTimeLineReservation[] | undefined;
}

export class PropertyTimeLineReservation implements IPropertyTimeLineReservation {
    id?: number;
    name?: string | undefined;
    from?: moment.Moment;
    to?: moment.Moment;
    total?: number;
    type?: string | undefined;

    constructor(data?: IPropertyTimeLineReservation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.from = _data["From"] ? moment(_data["From"].toString()) : <any>undefined;
            this.to = _data["To"] ? moment(_data["To"].toString()) : <any>undefined;
            this.total = _data["Total"];
            this.type = _data["Type"];
        }
    }

    static fromJS(data: any): PropertyTimeLineReservation {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyTimeLineReservation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["From"] = this.from ? this.from.toISOString() : <any>undefined;
        data["To"] = this.to ? this.to.toISOString() : <any>undefined;
        data["Total"] = this.total;
        data["Type"] = this.type;
        return data;
    }

    clone(): PropertyTimeLineReservation {
        const json = this.toJSON();
        let result = new PropertyTimeLineReservation();
        result.init(json);
        return result;
    }
}

export interface IPropertyTimeLineReservation {
    id?: number;
    name?: string | undefined;
    from?: moment.Moment;
    to?: moment.Moment;
    total?: number;
    type?: string | undefined;
}

export class ReservationModel implements IReservationModel {
    id?: number;
    rates?: BookRatesDetails | undefined;
    publicDetails?: PropertyPublicDetails | undefined;
    from?: moment.Moment;
    to?: moment.Moment;
    fullName?: string | undefined;
    email?: string | undefined;
    phone?: number | undefined;
    reservationCode?: string | undefined;
    status?: PropertyReservationStatus;
    canUpdateStatus?: boolean;
    guests?: number;
    pets?: number;
    paymentStatus?: GetReservationCompletionInfoModelStatus | undefined;
    receiptUrl?: string | undefined;
    paymentCreatedAt?: moment.Moment | undefined;
    paymentLink?: string | undefined;
    type?: string | undefined;
    canSendEmail?: boolean;

    constructor(data?: IReservationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.rates = _data["Rates"] ? BookRatesDetails.fromJS(_data["Rates"]) : <any>undefined;
            this.publicDetails = _data["PublicDetails"] ? PropertyPublicDetails.fromJS(_data["PublicDetails"]) : <any>undefined;
            this.from = _data["From"] ? moment(_data["From"].toString()) : <any>undefined;
            this.to = _data["To"] ? moment(_data["To"].toString()) : <any>undefined;
            this.fullName = _data["FullName"];
            this.email = _data["Email"];
            this.phone = _data["Phone"];
            this.reservationCode = _data["ReservationCode"];
            this.status = _data["Status"];
            this.canUpdateStatus = _data["CanUpdateStatus"];
            this.guests = _data["Guests"];
            this.pets = _data["Pets"];
            this.paymentStatus = _data["PaymentStatus"];
            this.receiptUrl = _data["ReceiptUrl"];
            this.paymentCreatedAt = _data["PaymentCreatedAt"] ? moment(_data["PaymentCreatedAt"].toString()) : <any>undefined;
            this.paymentLink = _data["PaymentLink"];
            this.type = _data["Type"];
            this.canSendEmail = _data["CanSendEmail"];
        }
    }

    static fromJS(data: any): ReservationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReservationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Rates"] = this.rates ? this.rates.toJSON() : <any>undefined;
        data["PublicDetails"] = this.publicDetails ? this.publicDetails.toJSON() : <any>undefined;
        data["From"] = this.from ? this.from.toISOString() : <any>undefined;
        data["To"] = this.to ? this.to.toISOString() : <any>undefined;
        data["FullName"] = this.fullName;
        data["Email"] = this.email;
        data["Phone"] = this.phone;
        data["ReservationCode"] = this.reservationCode;
        data["Status"] = this.status;
        data["CanUpdateStatus"] = this.canUpdateStatus;
        data["Guests"] = this.guests;
        data["Pets"] = this.pets;
        data["PaymentStatus"] = this.paymentStatus;
        data["ReceiptUrl"] = this.receiptUrl;
        data["PaymentCreatedAt"] = this.paymentCreatedAt ? this.paymentCreatedAt.toISOString() : <any>undefined;
        data["PaymentLink"] = this.paymentLink;
        data["Type"] = this.type;
        data["CanSendEmail"] = this.canSendEmail;
        return data;
    }

    clone(): ReservationModel {
        const json = this.toJSON();
        let result = new ReservationModel();
        result.init(json);
        return result;
    }
}

export interface IReservationModel {
    id?: number;
    rates?: BookRatesDetails | undefined;
    publicDetails?: PropertyPublicDetails | undefined;
    from?: moment.Moment;
    to?: moment.Moment;
    fullName?: string | undefined;
    email?: string | undefined;
    phone?: number | undefined;
    reservationCode?: string | undefined;
    status?: PropertyReservationStatus;
    canUpdateStatus?: boolean;
    guests?: number;
    pets?: number;
    paymentStatus?: GetReservationCompletionInfoModelStatus | undefined;
    receiptUrl?: string | undefined;
    paymentCreatedAt?: moment.Moment | undefined;
    paymentLink?: string | undefined;
    type?: string | undefined;
    canSendEmail?: boolean;
}

export class BookRatesDetails implements IBookRatesDetails {
    dayRates?: BookRateDayDetails[] | undefined;
    fees?: Charges[] | undefined;
    discounts?: Charges[] | undefined;
    taxes?: Charges[] | undefined;
    promoCodeId?: number | undefined;
    totalDayRent?: number;
    totalDiscounts?: number;
    totalFees?: number;
    totalTaxes?: number;
    total?: number;

    constructor(data?: IBookRatesDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["DayRates"])) {
                this.dayRates = [] as any;
                for (let item of _data["DayRates"])
                    this.dayRates!.push(BookRateDayDetails.fromJS(item));
            }
            if (Array.isArray(_data["Fees"])) {
                this.fees = [] as any;
                for (let item of _data["Fees"])
                    this.fees!.push(Charges.fromJS(item));
            }
            if (Array.isArray(_data["Discounts"])) {
                this.discounts = [] as any;
                for (let item of _data["Discounts"])
                    this.discounts!.push(Charges.fromJS(item));
            }
            if (Array.isArray(_data["Taxes"])) {
                this.taxes = [] as any;
                for (let item of _data["Taxes"])
                    this.taxes!.push(Charges.fromJS(item));
            }
            this.promoCodeId = _data["PromoCodeId"];
            this.totalDayRent = _data["TotalDayRent"];
            this.totalDiscounts = _data["TotalDiscounts"];
            this.totalFees = _data["TotalFees"];
            this.totalTaxes = _data["TotalTaxes"];
            this.total = _data["Total"];
        }
    }

    static fromJS(data: any): BookRatesDetails {
        data = typeof data === 'object' ? data : {};
        let result = new BookRatesDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dayRates)) {
            data["DayRates"] = [];
            for (let item of this.dayRates)
                data["DayRates"].push(item.toJSON());
        }
        if (Array.isArray(this.fees)) {
            data["Fees"] = [];
            for (let item of this.fees)
                data["Fees"].push(item.toJSON());
        }
        if (Array.isArray(this.discounts)) {
            data["Discounts"] = [];
            for (let item of this.discounts)
                data["Discounts"].push(item.toJSON());
        }
        if (Array.isArray(this.taxes)) {
            data["Taxes"] = [];
            for (let item of this.taxes)
                data["Taxes"].push(item.toJSON());
        }
        data["PromoCodeId"] = this.promoCodeId;
        data["TotalDayRent"] = this.totalDayRent;
        data["TotalDiscounts"] = this.totalDiscounts;
        data["TotalFees"] = this.totalFees;
        data["TotalTaxes"] = this.totalTaxes;
        data["Total"] = this.total;
        return data;
    }

    clone(): BookRatesDetails {
        const json = this.toJSON();
        let result = new BookRatesDetails();
        result.init(json);
        return result;
    }
}

export interface IBookRatesDetails {
    dayRates?: BookRateDayDetails[] | undefined;
    fees?: Charges[] | undefined;
    discounts?: Charges[] | undefined;
    taxes?: Charges[] | undefined;
    promoCodeId?: number | undefined;
    totalDayRent?: number;
    totalDiscounts?: number;
    totalFees?: number;
    totalTaxes?: number;
    total?: number;
}

export class BookRateDayDetails implements IBookRateDayDetails {
    day?: number;
    rate?: number;

    constructor(data?: IBookRateDayDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["Day"];
            this.rate = _data["Rate"];
        }
    }

    static fromJS(data: any): BookRateDayDetails {
        data = typeof data === 'object' ? data : {};
        let result = new BookRateDayDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Day"] = this.day;
        data["Rate"] = this.rate;
        return data;
    }

    clone(): BookRateDayDetails {
        const json = this.toJSON();
        let result = new BookRateDayDetails();
        result.init(json);
        return result;
    }
}

export interface IBookRateDayDetails {
    day?: number;
    rate?: number;
}

export class Charges implements ICharges {
    name?: string | undefined;
    rate?: number;

    constructor(data?: ICharges) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.rate = _data["Rate"];
        }
    }

    static fromJS(data: any): Charges {
        data = typeof data === 'object' ? data : {};
        let result = new Charges();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Rate"] = this.rate;
        return data;
    }

    clone(): Charges {
        const json = this.toJSON();
        let result = new Charges();
        result.init(json);
        return result;
    }
}

export interface ICharges {
    name?: string | undefined;
    rate?: number;
}

export class PropertyPublicDetails implements IPropertyPublicDetails {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    state?: string | undefined;
    stateDisplay?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
    latitude?: number;
    longitude?: number;
    type?: string | undefined;
    thumbnailImageUrl?: string | undefined;
    imageUrl?: string | undefined;
    petMax?: number;
    bathrooms?: number;
    bedrooms?: number;
    sleeps?: number;
    amenities?: string[] | undefined;
    minNights?: number;
    maxNights?: number | undefined;
    images?: PropertyPublicDetailsImage[] | undefined;
    beds?: PropertyPublicDetailsBed[] | undefined;
    rooms?: PropertyPublicDetailsRooms[] | undefined;
    maxGuests?: number | undefined;
    quietHoursStartTime?: number | undefined;
    quietHoursEndTime?: number | undefined;
    quietHoursEnabled?: boolean;
    partiesAllowed?: boolean;
    smokingAllowed?: boolean;
    policies?: string[] | undefined;
    houseRules?: string | undefined;

    constructor(data?: IPropertyPublicDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.description = _data["Description"];
            this.state = _data["State"];
            this.stateDisplay = _data["StateDisplay"];
            this.city = _data["City"];
            this.zipCode = _data["ZipCode"];
            this.latitude = _data["Latitude"];
            this.longitude = _data["Longitude"];
            this.type = _data["Type"];
            this.thumbnailImageUrl = _data["ThumbnailImageUrl"];
            this.imageUrl = _data["ImageUrl"];
            this.petMax = _data["PetMax"];
            this.bathrooms = _data["Bathrooms"];
            this.bedrooms = _data["Bedrooms"];
            this.sleeps = _data["Sleeps"];
            if (Array.isArray(_data["Amenities"])) {
                this.amenities = [] as any;
                for (let item of _data["Amenities"])
                    this.amenities!.push(item);
            }
            this.minNights = _data["MinNights"];
            this.maxNights = _data["MaxNights"];
            if (Array.isArray(_data["Images"])) {
                this.images = [] as any;
                for (let item of _data["Images"])
                    this.images!.push(PropertyPublicDetailsImage.fromJS(item));
            }
            if (Array.isArray(_data["Beds"])) {
                this.beds = [] as any;
                for (let item of _data["Beds"])
                    this.beds!.push(PropertyPublicDetailsBed.fromJS(item));
            }
            if (Array.isArray(_data["Rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["Rooms"])
                    this.rooms!.push(PropertyPublicDetailsRooms.fromJS(item));
            }
            this.maxGuests = _data["MaxGuests"];
            this.quietHoursStartTime = _data["QuietHoursStartTime"];
            this.quietHoursEndTime = _data["QuietHoursEndTime"];
            this.quietHoursEnabled = _data["QuietHoursEnabled"];
            this.partiesAllowed = _data["PartiesAllowed"];
            this.smokingAllowed = _data["SmokingAllowed"];
            if (Array.isArray(_data["Policies"])) {
                this.policies = [] as any;
                for (let item of _data["Policies"])
                    this.policies!.push(item);
            }
            this.houseRules = _data["HouseRules"];
        }
    }

    static fromJS(data: any): PropertyPublicDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyPublicDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Description"] = this.description;
        data["State"] = this.state;
        data["StateDisplay"] = this.stateDisplay;
        data["City"] = this.city;
        data["ZipCode"] = this.zipCode;
        data["Latitude"] = this.latitude;
        data["Longitude"] = this.longitude;
        data["Type"] = this.type;
        data["ThumbnailImageUrl"] = this.thumbnailImageUrl;
        data["ImageUrl"] = this.imageUrl;
        data["PetMax"] = this.petMax;
        data["Bathrooms"] = this.bathrooms;
        data["Bedrooms"] = this.bedrooms;
        data["Sleeps"] = this.sleeps;
        if (Array.isArray(this.amenities)) {
            data["Amenities"] = [];
            for (let item of this.amenities)
                data["Amenities"].push(item);
        }
        data["MinNights"] = this.minNights;
        data["MaxNights"] = this.maxNights;
        if (Array.isArray(this.images)) {
            data["Images"] = [];
            for (let item of this.images)
                data["Images"].push(item.toJSON());
        }
        if (Array.isArray(this.beds)) {
            data["Beds"] = [];
            for (let item of this.beds)
                data["Beds"].push(item.toJSON());
        }
        if (Array.isArray(this.rooms)) {
            data["Rooms"] = [];
            for (let item of this.rooms)
                data["Rooms"].push(item.toJSON());
        }
        data["MaxGuests"] = this.maxGuests;
        data["QuietHoursStartTime"] = this.quietHoursStartTime;
        data["QuietHoursEndTime"] = this.quietHoursEndTime;
        data["QuietHoursEnabled"] = this.quietHoursEnabled;
        data["PartiesAllowed"] = this.partiesAllowed;
        data["SmokingAllowed"] = this.smokingAllowed;
        if (Array.isArray(this.policies)) {
            data["Policies"] = [];
            for (let item of this.policies)
                data["Policies"].push(item);
        }
        data["HouseRules"] = this.houseRules;
        return data;
    }

    clone(): PropertyPublicDetails {
        const json = this.toJSON();
        let result = new PropertyPublicDetails();
        result.init(json);
        return result;
    }
}

export interface IPropertyPublicDetails {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    state?: string | undefined;
    stateDisplay?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
    latitude?: number;
    longitude?: number;
    type?: string | undefined;
    thumbnailImageUrl?: string | undefined;
    imageUrl?: string | undefined;
    petMax?: number;
    bathrooms?: number;
    bedrooms?: number;
    sleeps?: number;
    amenities?: string[] | undefined;
    minNights?: number;
    maxNights?: number | undefined;
    images?: PropertyPublicDetailsImage[] | undefined;
    beds?: PropertyPublicDetailsBed[] | undefined;
    rooms?: PropertyPublicDetailsRooms[] | undefined;
    maxGuests?: number | undefined;
    quietHoursStartTime?: number | undefined;
    quietHoursEndTime?: number | undefined;
    quietHoursEnabled?: boolean;
    partiesAllowed?: boolean;
    smokingAllowed?: boolean;
    policies?: string[] | undefined;
    houseRules?: string | undefined;
}

export class PropertyPublicDetailsImage implements IPropertyPublicDetailsImage {
    url?: string | undefined;
    thumbnailUrl?: string | undefined;

    constructor(data?: IPropertyPublicDetailsImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.thumbnailUrl = _data["thumbnailUrl"];
        }
    }

    static fromJS(data: any): PropertyPublicDetailsImage {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyPublicDetailsImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["thumbnailUrl"] = this.thumbnailUrl;
        return data;
    }

    clone(): PropertyPublicDetailsImage {
        const json = this.toJSON();
        let result = new PropertyPublicDetailsImage();
        result.init(json);
        return result;
    }
}

export interface IPropertyPublicDetailsImage {
    url?: string | undefined;
    thumbnailUrl?: string | undefined;
}

export class PropertyPublicDetailsBed implements IPropertyPublicDetailsBed {
    type?: string | undefined;
    count?: number;

    constructor(data?: IPropertyPublicDetailsBed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): PropertyPublicDetailsBed {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyPublicDetailsBed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["count"] = this.count;
        return data;
    }

    clone(): PropertyPublicDetailsBed {
        const json = this.toJSON();
        let result = new PropertyPublicDetailsBed();
        result.init(json);
        return result;
    }
}

export interface IPropertyPublicDetailsBed {
    type?: string | undefined;
    count?: number;
}

export class PropertyPublicDetailsRooms implements IPropertyPublicDetailsRooms {
    name?: string | undefined;
    sleeps?: number;
    rooms?: PropertyPublicDetailsBed[] | undefined;

    constructor(data?: IPropertyPublicDetailsRooms) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sleeps = _data["sleeps"];
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms!.push(PropertyPublicDetailsBed.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertyPublicDetailsRooms {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyPublicDetailsRooms();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sleeps"] = this.sleeps;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        return data;
    }

    clone(): PropertyPublicDetailsRooms {
        const json = this.toJSON();
        let result = new PropertyPublicDetailsRooms();
        result.init(json);
        return result;
    }
}

export interface IPropertyPublicDetailsRooms {
    name?: string | undefined;
    sleeps?: number;
    rooms?: PropertyPublicDetailsBed[] | undefined;
}

export class CalendarMonthGroup implements ICalendarMonthGroup {
    year?: number;
    month?: number;
    startDay?: number;
    days?: CalendarDay[] | undefined;

    constructor(data?: ICalendarMonthGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["Year"];
            this.month = _data["Month"];
            this.startDay = _data["StartDay"];
            if (Array.isArray(_data["Days"])) {
                this.days = [] as any;
                for (let item of _data["Days"])
                    this.days!.push(CalendarDay.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalendarMonthGroup {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarMonthGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Year"] = this.year;
        data["Month"] = this.month;
        data["StartDay"] = this.startDay;
        if (Array.isArray(this.days)) {
            data["Days"] = [];
            for (let item of this.days)
                data["Days"].push(item.toJSON());
        }
        return data;
    }

    clone(): CalendarMonthGroup {
        const json = this.toJSON();
        let result = new CalendarMonthGroup();
        result.init(json);
        return result;
    }
}

export interface ICalendarMonthGroup {
    year?: number;
    month?: number;
    startDay?: number;
    days?: CalendarDay[] | undefined;
}

export class CalendarDay implements ICalendarDay {
    status?: PropertyCalendarItemStatus;
    rate?: number | undefined;
    discountRate?: number | undefined;
    isOverridden?: boolean;
    date?: number;
    prevStatus?: PropertyCalendarItemStatus | undefined;

    constructor(data?: ICalendarDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["Status"];
            this.rate = _data["Rate"];
            this.discountRate = _data["DiscountRate"];
            this.isOverridden = _data["IsOverridden"];
            this.date = _data["Date"];
            this.prevStatus = _data["PrevStatus"];
        }
    }

    static fromJS(data: any): CalendarDay {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Status"] = this.status;
        data["Rate"] = this.rate;
        data["DiscountRate"] = this.discountRate;
        data["IsOverridden"] = this.isOverridden;
        data["Date"] = this.date;
        data["PrevStatus"] = this.prevStatus;
        return data;
    }

    clone(): CalendarDay {
        const json = this.toJSON();
        let result = new CalendarDay();
        result.init(json);
        return result;
    }
}

export interface ICalendarDay {
    status?: PropertyCalendarItemStatus;
    rate?: number | undefined;
    discountRate?: number | undefined;
    isOverridden?: boolean;
    date?: number;
    prevStatus?: PropertyCalendarItemStatus | undefined;
}

/** 1 = Available 2 = Reserved 3 = Unavailable */
export enum PropertyCalendarItemStatus {
    Available = 1,
    Reserved = 2,
    Unavailable = 3,
}

export class IntegrationReservationTimeLineGroup implements IIntegrationReservationTimeLineGroup {
    id?: number;
    name?: string | undefined;
    reservations?: IntegrationReservationTimeLine[] | undefined;

    constructor(data?: IIntegrationReservationTimeLineGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            if (Array.isArray(_data["Reservations"])) {
                this.reservations = [] as any;
                for (let item of _data["Reservations"])
                    this.reservations!.push(IntegrationReservationTimeLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IntegrationReservationTimeLineGroup {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationReservationTimeLineGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        if (Array.isArray(this.reservations)) {
            data["Reservations"] = [];
            for (let item of this.reservations)
                data["Reservations"].push(item.toJSON());
        }
        return data;
    }

    clone(): IntegrationReservationTimeLineGroup {
        const json = this.toJSON();
        let result = new IntegrationReservationTimeLineGroup();
        result.init(json);
        return result;
    }
}

export interface IIntegrationReservationTimeLineGroup {
    id?: number;
    name?: string | undefined;
    reservations?: IntegrationReservationTimeLine[] | undefined;
}

export class IntegrationReservationTimeLine implements IIntegrationReservationTimeLine {
    id?: number;
    from?: moment.Moment;
    to?: moment.Moment;
    source?: string | undefined;
    guestName?: string | undefined;
    listing?: string | undefined;
    confirmationCode?: string | undefined;
    type?: IntegrationType;
    createdAt?: moment.Moment;
    updatedAt?: moment.Moment | undefined;
    reservationId?: number | undefined;
    status?: HosttoolsItemStatus;
    lastError?: string | undefined;

    constructor(data?: IIntegrationReservationTimeLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.from = _data["From"] ? moment(_data["From"].toString()) : <any>undefined;
            this.to = _data["To"] ? moment(_data["To"].toString()) : <any>undefined;
            this.source = _data["Source"];
            this.guestName = _data["GuestName"];
            this.listing = _data["Listing"];
            this.confirmationCode = _data["ConfirmationCode"];
            this.type = _data["Type"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.updatedAt = _data["UpdatedAt"] ? moment(_data["UpdatedAt"].toString()) : <any>undefined;
            this.reservationId = _data["ReservationId"];
            this.status = _data["Status"];
            this.lastError = _data["LastError"];
        }
    }

    static fromJS(data: any): IntegrationReservationTimeLine {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationReservationTimeLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["From"] = this.from ? this.from.toISOString() : <any>undefined;
        data["To"] = this.to ? this.to.toISOString() : <any>undefined;
        data["Source"] = this.source;
        data["GuestName"] = this.guestName;
        data["Listing"] = this.listing;
        data["ConfirmationCode"] = this.confirmationCode;
        data["Type"] = this.type;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["UpdatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["ReservationId"] = this.reservationId;
        data["Status"] = this.status;
        data["LastError"] = this.lastError;
        return data;
    }

    clone(): IntegrationReservationTimeLine {
        const json = this.toJSON();
        let result = new IntegrationReservationTimeLine();
        result.init(json);
        return result;
    }
}

export interface IIntegrationReservationTimeLine {
    id?: number;
    from?: moment.Moment;
    to?: moment.Moment;
    source?: string | undefined;
    guestName?: string | undefined;
    listing?: string | undefined;
    confirmationCode?: string | undefined;
    type?: IntegrationType;
    createdAt?: moment.Moment;
    updatedAt?: moment.Moment | undefined;
    reservationId?: number | undefined;
    status?: HosttoolsItemStatus;
    lastError?: string | undefined;
}

/** 1 = HosttoolsWebHook 2 = HosttoolsApi 3 = HostawayApi 4 = HostawayWebHook */
export enum IntegrationType {
    HosttoolsWebHook = 1,
    HosttoolsApi = 2,
    HostawayApi = 3,
    HostawayWebHook = 4,
}

/** 1 = NeedToCreate 2 = NeedToUpdate 3 = NeedToCancel 4 = Processed */
export enum HosttoolsItemStatus {
    NeedToCreate = 1,
    NeedToUpdate = 2,
    NeedToCancel = 3,
    Processed = 4,
}

export class IntegrationReservationLog implements IIntegrationReservationLog {
    id?: number;
    createdAt?: moment.Moment;
    operation?: string | undefined;
    data?: string | undefined;

    constructor(data?: IIntegrationReservationLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.operation = _data["Operation"];
            this.data = _data["Data"];
        }
    }

    static fromJS(data: any): IntegrationReservationLog {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationReservationLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["Operation"] = this.operation;
        data["Data"] = this.data;
        return data;
    }

    clone(): IntegrationReservationLog {
        const json = this.toJSON();
        let result = new IntegrationReservationLog();
        result.init(json);
        return result;
    }
}

export interface IIntegrationReservationLog {
    id?: number;
    createdAt?: moment.Moment;
    operation?: string | undefined;
    data?: string | undefined;
}

export class HostToolsListingSummary implements IHostToolsListingSummary {
    syncId?: number;
    integrationId?: number;
    listingId?: string;
    name?: string;
    status?: string;
    isIgnored?: boolean;
    lastSeenAt?: moment.Moment;
    updatedAt?: moment.Moment;
    lastSyncedAt?: moment.Moment | undefined;
    propertyId?: number | undefined;
    propertyName?: string | undefined;
    propertyInternalName?: string | undefined;
    propertyStatus?: PropertyStatus | undefined;
    hostListing?: HostToolsListingResponse | undefined;
    isPending?: boolean;

    constructor(data?: IHostToolsListingSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.syncId = _data["SyncId"];
            this.integrationId = _data["IntegrationId"];
            this.listingId = _data["ListingId"];
            this.name = _data["Name"];
            this.status = _data["Status"];
            this.isIgnored = _data["IsIgnored"];
            this.lastSeenAt = _data["LastSeenAt"] ? moment(_data["LastSeenAt"].toString()) : <any>undefined;
            this.updatedAt = _data["UpdatedAt"] ? moment(_data["UpdatedAt"].toString()) : <any>undefined;
            this.lastSyncedAt = _data["LastSyncedAt"] ? moment(_data["LastSyncedAt"].toString()) : <any>undefined;
            this.propertyId = _data["PropertyId"];
            this.propertyName = _data["PropertyName"];
            this.propertyInternalName = _data["PropertyInternalName"];
            this.propertyStatus = _data["PropertyStatus"];
            this.hostListing = _data["HostListing"] ? HostToolsListingResponse.fromJS(_data["HostListing"]) : <any>undefined;
            this.isPending = _data["IsPending"];
        }
    }

    static fromJS(data: any): HostToolsListingSummary {
        data = typeof data === 'object' ? data : {};
        let result = new HostToolsListingSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["SyncId"] = this.syncId;
        data["IntegrationId"] = this.integrationId;
        data["ListingId"] = this.listingId;
        data["Name"] = this.name;
        data["Status"] = this.status;
        data["IsIgnored"] = this.isIgnored;
        data["LastSeenAt"] = this.lastSeenAt ? this.lastSeenAt.toISOString() : <any>undefined;
        data["UpdatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["LastSyncedAt"] = this.lastSyncedAt ? this.lastSyncedAt.toISOString() : <any>undefined;
        data["PropertyId"] = this.propertyId;
        data["PropertyName"] = this.propertyName;
        data["PropertyInternalName"] = this.propertyInternalName;
        data["PropertyStatus"] = this.propertyStatus;
        data["HostListing"] = this.hostListing ? this.hostListing.toJSON() : <any>undefined;
        data["IsPending"] = this.isPending;
        return data;
    }

    clone(): HostToolsListingSummary {
        const json = this.toJSON();
        let result = new HostToolsListingSummary();
        result.init(json);
        return result;
    }
}

export interface IHostToolsListingSummary {
    syncId?: number;
    integrationId?: number;
    listingId?: string;
    name?: string;
    status?: string;
    isIgnored?: boolean;
    lastSeenAt?: moment.Moment;
    updatedAt?: moment.Moment;
    lastSyncedAt?: moment.Moment | undefined;
    propertyId?: number | undefined;
    propertyName?: string | undefined;
    propertyInternalName?: string | undefined;
    propertyStatus?: PropertyStatus | undefined;
    hostListing?: HostToolsListingResponse | undefined;
    isPending?: boolean;
}

/** 1 = Listed 2 = Unlisted 3 = Deactivated */
export enum PropertyStatus {
    Listed = 1,
    Unlisted = 2,
    Deactivated = 3,
}

export class HostToolsListingResponse implements IHostToolsListingResponse {
    _id?: string | undefined;
    userID?: string | undefined;
    name?: string | undefined;
    thumbnailUrl?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    countryCode?: string | undefined;
    region?: string | undefined;
    state?: string | undefined;
    zipcode?: string | undefined;
    zip_code?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    propertyType?: string | undefined;
    roomType?: string | undefined;
    maxGuests?: number | undefined;
    accommodates?: number | undefined;
    bedrooms?: number | undefined;
    bathrooms?: number | undefined;
    beds?: number | undefined;
    amenities?: string[] | undefined;
    notes?: HostToolsListingNotes | undefined;
    keyCollection?: HostToolsKeyCollection | undefined;
    policy?: HostToolsPolicy | undefined;
    checkInTime?: number | undefined;
    checkOutTime?: number | undefined;
    check_in_time?: string | undefined;
    check_out_time?: string | undefined;
    minNights?: number | undefined;
    minimum_nights?: number | undefined;
    maxNights?: number | undefined;
    maximum_nights?: number | undefined;
    basePrice?: number | undefined;
    base_price?: number | undefined;
    cleaningFee?: number | undefined;
    cleaning_fee?: number | undefined;
    securityDeposit?: number | undefined;
    security_deposit?: number | undefined;
    currency?: string | undefined;
    timeZone?: string | undefined;
    space?: number | undefined;
    spaceUnit?: string | undefined;
    images?: HostToolsImage[] | undefined;
    status?: string | undefined;
    created_at?: moment.Moment | undefined;
    updated_at?: moment.Moment | undefined;
    attributesWithQuantity?: HostToolsAttributeWithQuantity[] | undefined;
    bedroomConfiguration?: HostToolsBedroomConfiguration | undefined;

    [key: string]: any;

    constructor(data?: IHostToolsListingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this._id = _data["_id"];
            this.userID = _data["userID"];
            this.name = _data["name"];
            this.thumbnailUrl = _data["thumbnailUrl"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.countryCode = _data["countryCode"];
            this.region = _data["region"];
            this.state = _data["state"];
            this.zipcode = _data["zipcode"];
            this.zip_code = _data["zip_code"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.propertyType = _data["propertyType"];
            this.roomType = _data["roomType"];
            this.maxGuests = _data["maxGuests"];
            this.accommodates = _data["accommodates"];
            this.bedrooms = _data["bedrooms"];
            this.bathrooms = _data["bathrooms"];
            this.beds = _data["beds"];
            if (Array.isArray(_data["amenities"])) {
                this.amenities = [] as any;
                for (let item of _data["amenities"])
                    this.amenities!.push(item);
            }
            this.notes = _data["notes"] ? HostToolsListingNotes.fromJS(_data["notes"]) : <any>undefined;
            this.keyCollection = _data["keyCollection"] ? HostToolsKeyCollection.fromJS(_data["keyCollection"]) : <any>undefined;
            this.policy = _data["policy"] ? HostToolsPolicy.fromJS(_data["policy"]) : <any>undefined;
            this.checkInTime = _data["checkInTime"];
            this.checkOutTime = _data["checkOutTime"];
            this.check_in_time = _data["check_in_time"];
            this.check_out_time = _data["check_out_time"];
            this.minNights = _data["minNights"];
            this.minimum_nights = _data["minimum_nights"];
            this.maxNights = _data["maxNights"];
            this.maximum_nights = _data["maximum_nights"];
            this.basePrice = _data["basePrice"];
            this.base_price = _data["base_price"];
            this.cleaningFee = _data["cleaningFee"];
            this.cleaning_fee = _data["cleaning_fee"];
            this.securityDeposit = _data["securityDeposit"];
            this.security_deposit = _data["security_deposit"];
            this.currency = _data["currency"];
            this.timeZone = _data["timeZone"];
            this.space = _data["space"];
            this.spaceUnit = _data["spaceUnit"];
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(HostToolsImage.fromJS(item));
            }
            this.status = _data["status"];
            this.created_at = _data["created_at"] ? moment(_data["created_at"].toString()) : <any>undefined;
            this.updated_at = _data["updated_at"] ? moment(_data["updated_at"].toString()) : <any>undefined;
            if (Array.isArray(_data["attributesWithQuantity"])) {
                this.attributesWithQuantity = [] as any;
                for (let item of _data["attributesWithQuantity"])
                    this.attributesWithQuantity!.push(HostToolsAttributeWithQuantity.fromJS(item));
            }
            this.bedroomConfiguration = _data["bedroomConfiguration"] ? HostToolsBedroomConfiguration.fromJS(_data["bedroomConfiguration"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostToolsListingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HostToolsListingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["_id"] = this._id;
        data["userID"] = this.userID;
        data["name"] = this.name;
        data["thumbnailUrl"] = this.thumbnailUrl;
        data["address"] = this.address;
        data["city"] = this.city;
        data["country"] = this.country;
        data["countryCode"] = this.countryCode;
        data["region"] = this.region;
        data["state"] = this.state;
        data["zipcode"] = this.zipcode;
        data["zip_code"] = this.zip_code;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["propertyType"] = this.propertyType;
        data["roomType"] = this.roomType;
        data["maxGuests"] = this.maxGuests;
        data["accommodates"] = this.accommodates;
        data["bedrooms"] = this.bedrooms;
        data["bathrooms"] = this.bathrooms;
        data["beds"] = this.beds;
        if (Array.isArray(this.amenities)) {
            data["amenities"] = [];
            for (let item of this.amenities)
                data["amenities"].push(item);
        }
        data["notes"] = this.notes ? this.notes.toJSON() : <any>undefined;
        data["keyCollection"] = this.keyCollection ? this.keyCollection.toJSON() : <any>undefined;
        data["policy"] = this.policy ? this.policy.toJSON() : <any>undefined;
        data["checkInTime"] = this.checkInTime;
        data["checkOutTime"] = this.checkOutTime;
        data["check_in_time"] = this.check_in_time;
        data["check_out_time"] = this.check_out_time;
        data["minNights"] = this.minNights;
        data["minimum_nights"] = this.minimum_nights;
        data["maxNights"] = this.maxNights;
        data["maximum_nights"] = this.maximum_nights;
        data["basePrice"] = this.basePrice;
        data["base_price"] = this.base_price;
        data["cleaningFee"] = this.cleaningFee;
        data["cleaning_fee"] = this.cleaning_fee;
        data["securityDeposit"] = this.securityDeposit;
        data["security_deposit"] = this.security_deposit;
        data["currency"] = this.currency;
        data["timeZone"] = this.timeZone;
        data["space"] = this.space;
        data["spaceUnit"] = this.spaceUnit;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["status"] = this.status;
        data["created_at"] = this.created_at ? this.created_at.toISOString() : <any>undefined;
        data["updated_at"] = this.updated_at ? this.updated_at.toISOString() : <any>undefined;
        if (Array.isArray(this.attributesWithQuantity)) {
            data["attributesWithQuantity"] = [];
            for (let item of this.attributesWithQuantity)
                data["attributesWithQuantity"].push(item.toJSON());
        }
        data["bedroomConfiguration"] = this.bedroomConfiguration ? this.bedroomConfiguration.toJSON() : <any>undefined;
        return data;
    }

    clone(): HostToolsListingResponse {
        const json = this.toJSON();
        let result = new HostToolsListingResponse();
        result.init(json);
        return result;
    }
}

export interface IHostToolsListingResponse {
    _id?: string | undefined;
    userID?: string | undefined;
    name?: string | undefined;
    thumbnailUrl?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    country?: string | undefined;
    countryCode?: string | undefined;
    region?: string | undefined;
    state?: string | undefined;
    zipcode?: string | undefined;
    zip_code?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    propertyType?: string | undefined;
    roomType?: string | undefined;
    maxGuests?: number | undefined;
    accommodates?: number | undefined;
    bedrooms?: number | undefined;
    bathrooms?: number | undefined;
    beds?: number | undefined;
    amenities?: string[] | undefined;
    notes?: HostToolsListingNotes | undefined;
    keyCollection?: HostToolsKeyCollection | undefined;
    policy?: HostToolsPolicy | undefined;
    checkInTime?: number | undefined;
    checkOutTime?: number | undefined;
    check_in_time?: string | undefined;
    check_out_time?: string | undefined;
    minNights?: number | undefined;
    minimum_nights?: number | undefined;
    maxNights?: number | undefined;
    maximum_nights?: number | undefined;
    basePrice?: number | undefined;
    base_price?: number | undefined;
    cleaningFee?: number | undefined;
    cleaning_fee?: number | undefined;
    securityDeposit?: number | undefined;
    security_deposit?: number | undefined;
    currency?: string | undefined;
    timeZone?: string | undefined;
    space?: number | undefined;
    spaceUnit?: string | undefined;
    images?: HostToolsImage[] | undefined;
    status?: string | undefined;
    created_at?: moment.Moment | undefined;
    updated_at?: moment.Moment | undefined;
    attributesWithQuantity?: HostToolsAttributeWithQuantity[] | undefined;
    bedroomConfiguration?: HostToolsBedroomConfiguration | undefined;

    [key: string]: any;
}

export class HostToolsListingNotes implements IHostToolsListingNotes {
    description?: HostToolsLocalizedTextCollection | undefined;
    shortDescription?: HostToolsLocalizedTextCollection | undefined;
    neighborhoodOverview?: HostToolsLocalizedText | undefined;

    constructor(data?: IHostToolsListingNotes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] ? HostToolsLocalizedTextCollection.fromJS(_data["description"]) : <any>undefined;
            this.shortDescription = _data["shortDescription"] ? HostToolsLocalizedTextCollection.fromJS(_data["shortDescription"]) : <any>undefined;
            this.neighborhoodOverview = _data["neighborhoodOverview"] ? HostToolsLocalizedText.fromJS(_data["neighborhoodOverview"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostToolsListingNotes {
        data = typeof data === 'object' ? data : {};
        let result = new HostToolsListingNotes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        data["shortDescription"] = this.shortDescription ? this.shortDescription.toJSON() : <any>undefined;
        data["neighborhoodOverview"] = this.neighborhoodOverview ? this.neighborhoodOverview.toJSON() : <any>undefined;
        return data;
    }

    clone(): HostToolsListingNotes {
        const json = this.toJSON();
        let result = new HostToolsListingNotes();
        result.init(json);
        return result;
    }
}

export interface IHostToolsListingNotes {
    description?: HostToolsLocalizedTextCollection | undefined;
    shortDescription?: HostToolsLocalizedTextCollection | undefined;
    neighborhoodOverview?: HostToolsLocalizedText | undefined;
}

export class HostToolsLocalizedTextCollection implements IHostToolsLocalizedTextCollection {
    texts?: HostToolsLocalizedText[] | undefined;

    constructor(data?: IHostToolsLocalizedTextCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["texts"])) {
                this.texts = [] as any;
                for (let item of _data["texts"])
                    this.texts!.push(HostToolsLocalizedText.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HostToolsLocalizedTextCollection {
        data = typeof data === 'object' ? data : {};
        let result = new HostToolsLocalizedTextCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.texts)) {
            data["texts"] = [];
            for (let item of this.texts)
                data["texts"].push(item.toJSON());
        }
        return data;
    }

    clone(): HostToolsLocalizedTextCollection {
        const json = this.toJSON();
        let result = new HostToolsLocalizedTextCollection();
        result.init(json);
        return result;
    }
}

export interface IHostToolsLocalizedTextCollection {
    texts?: HostToolsLocalizedText[] | undefined;
}

export class HostToolsLocalizedText implements IHostToolsLocalizedText {
    language?: string | undefined;
    value?: string | undefined;

    constructor(data?: IHostToolsLocalizedText) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): HostToolsLocalizedText {
        data = typeof data === 'object' ? data : {};
        let result = new HostToolsLocalizedText();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["value"] = this.value;
        return data;
    }

    clone(): HostToolsLocalizedText {
        const json = this.toJSON();
        let result = new HostToolsLocalizedText();
        result.init(json);
        return result;
    }
}

export interface IHostToolsLocalizedText {
    language?: string | undefined;
    value?: string | undefined;
}

export class HostToolsKeyCollection implements IHostToolsKeyCollection {
    type?: string | undefined;
    checkInMethod?: string | undefined;
    additionalInfo?: HostToolsKeyCollectionAdditionalInfo | undefined;

    constructor(data?: IHostToolsKeyCollection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.checkInMethod = _data["checkInMethod"];
            this.additionalInfo = _data["additionalInfo"] ? HostToolsKeyCollectionAdditionalInfo.fromJS(_data["additionalInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostToolsKeyCollection {
        data = typeof data === 'object' ? data : {};
        let result = new HostToolsKeyCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["checkInMethod"] = this.checkInMethod;
        data["additionalInfo"] = this.additionalInfo ? this.additionalInfo.toJSON() : <any>undefined;
        return data;
    }

    clone(): HostToolsKeyCollection {
        const json = this.toJSON();
        let result = new HostToolsKeyCollection();
        result.init(json);
        return result;
    }
}

export interface IHostToolsKeyCollection {
    type?: string | undefined;
    checkInMethod?: string | undefined;
    additionalInfo?: HostToolsKeyCollectionAdditionalInfo | undefined;
}

export class HostToolsKeyCollectionAdditionalInfo implements IHostToolsKeyCollectionAdditionalInfo {
    instruction?: HostToolsInstruction | undefined;

    constructor(data?: IHostToolsKeyCollectionAdditionalInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.instruction = _data["instruction"] ? HostToolsInstruction.fromJS(_data["instruction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostToolsKeyCollectionAdditionalInfo {
        data = typeof data === 'object' ? data : {};
        let result = new HostToolsKeyCollectionAdditionalInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instruction"] = this.instruction ? this.instruction.toJSON() : <any>undefined;
        return data;
    }

    clone(): HostToolsKeyCollectionAdditionalInfo {
        const json = this.toJSON();
        let result = new HostToolsKeyCollectionAdditionalInfo();
        result.init(json);
        return result;
    }
}

export interface IHostToolsKeyCollectionAdditionalInfo {
    instruction?: HostToolsInstruction | undefined;
}

export class HostToolsInstruction implements IHostToolsInstruction {
    how?: string | undefined;
    when?: string | undefined;

    constructor(data?: IHostToolsInstruction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.how = _data["how"];
            this.when = _data["when"];
        }
    }

    static fromJS(data: any): HostToolsInstruction {
        data = typeof data === 'object' ? data : {};
        let result = new HostToolsInstruction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["how"] = this.how;
        data["when"] = this.when;
        return data;
    }

    clone(): HostToolsInstruction {
        const json = this.toJSON();
        let result = new HostToolsInstruction();
        result.init(json);
        return result;
    }
}

export interface IHostToolsInstruction {
    how?: string | undefined;
    when?: string | undefined;
}

export class HostToolsPolicy implements IHostToolsPolicy {
    internetPolicy?: HostToolsInternetPolicy | undefined;
    parkingPolicy?: HostToolsParkingPolicy | undefined;
    petPolicy?: HostToolsPetPolicy | undefined;
    houseRules?: HostToolsLocalizedTextCollection | undefined;
    cancellationPolicy?: string | undefined;
    childrenAllowed?: boolean | undefined;
    smokingAllowed?: boolean | undefined;

    constructor(data?: IHostToolsPolicy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internetPolicy = _data["internetPolicy"] ? HostToolsInternetPolicy.fromJS(_data["internetPolicy"]) : <any>undefined;
            this.parkingPolicy = _data["parkingPolicy"] ? HostToolsParkingPolicy.fromJS(_data["parkingPolicy"]) : <any>undefined;
            this.petPolicy = _data["petPolicy"] ? HostToolsPetPolicy.fromJS(_data["petPolicy"]) : <any>undefined;
            this.houseRules = _data["houseRules"] ? HostToolsLocalizedTextCollection.fromJS(_data["houseRules"]) : <any>undefined;
            this.cancellationPolicy = _data["cancellationPolicy"];
            this.childrenAllowed = _data["childrenAllowed"];
            this.smokingAllowed = _data["smokingAllowed"];
        }
    }

    static fromJS(data: any): HostToolsPolicy {
        data = typeof data === 'object' ? data : {};
        let result = new HostToolsPolicy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internetPolicy"] = this.internetPolicy ? this.internetPolicy.toJSON() : <any>undefined;
        data["parkingPolicy"] = this.parkingPolicy ? this.parkingPolicy.toJSON() : <any>undefined;
        data["petPolicy"] = this.petPolicy ? this.petPolicy.toJSON() : <any>undefined;
        data["houseRules"] = this.houseRules ? this.houseRules.toJSON() : <any>undefined;
        data["cancellationPolicy"] = this.cancellationPolicy;
        data["childrenAllowed"] = this.childrenAllowed;
        data["smokingAllowed"] = this.smokingAllowed;
        return data;
    }

    clone(): HostToolsPolicy {
        const json = this.toJSON();
        let result = new HostToolsPolicy();
        result.init(json);
        return result;
    }
}

export interface IHostToolsPolicy {
    internetPolicy?: HostToolsInternetPolicy | undefined;
    parkingPolicy?: HostToolsParkingPolicy | undefined;
    petPolicy?: HostToolsPetPolicy | undefined;
    houseRules?: HostToolsLocalizedTextCollection | undefined;
    cancellationPolicy?: string | undefined;
    childrenAllowed?: boolean | undefined;
    smokingAllowed?: boolean | undefined;
}

export class HostToolsInternetPolicy implements IHostToolsInternetPolicy {
    accessInternet?: boolean | undefined;
    kindOfInternet?: string | undefined;
    chargeInternet?: string | undefined;

    constructor(data?: IHostToolsInternetPolicy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessInternet = _data["accessInternet"];
            this.kindOfInternet = _data["kindOfInternet"];
            this.chargeInternet = _data["chargeInternet"];
        }
    }

    static fromJS(data: any): HostToolsInternetPolicy {
        data = typeof data === 'object' ? data : {};
        let result = new HostToolsInternetPolicy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessInternet"] = this.accessInternet;
        data["kindOfInternet"] = this.kindOfInternet;
        data["chargeInternet"] = this.chargeInternet;
        return data;
    }

    clone(): HostToolsInternetPolicy {
        const json = this.toJSON();
        let result = new HostToolsInternetPolicy();
        result.init(json);
        return result;
    }
}

export interface IHostToolsInternetPolicy {
    accessInternet?: boolean | undefined;
    kindOfInternet?: string | undefined;
    chargeInternet?: string | undefined;
}

export class HostToolsParkingPolicy implements IHostToolsParkingPolicy {
    accessParking?: boolean | undefined;
    chargeParking?: string | undefined;

    constructor(data?: IHostToolsParkingPolicy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessParking = _data["accessParking"];
            this.chargeParking = _data["chargeParking"];
        }
    }

    static fromJS(data: any): HostToolsParkingPolicy {
        data = typeof data === 'object' ? data : {};
        let result = new HostToolsParkingPolicy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessParking"] = this.accessParking;
        data["chargeParking"] = this.chargeParking;
        return data;
    }

    clone(): HostToolsParkingPolicy {
        const json = this.toJSON();
        let result = new HostToolsParkingPolicy();
        result.init(json);
        return result;
    }
}

export interface IHostToolsParkingPolicy {
    accessParking?: boolean | undefined;
    chargeParking?: string | undefined;
}

export class HostToolsPetPolicy implements IHostToolsPetPolicy {
    allowedPets?: string | undefined;
    chargePets?: string | undefined;

    constructor(data?: IHostToolsPetPolicy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowedPets = _data["allowedPets"];
            this.chargePets = _data["chargePets"];
        }
    }

    static fromJS(data: any): HostToolsPetPolicy {
        data = typeof data === 'object' ? data : {};
        let result = new HostToolsPetPolicy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowedPets"] = this.allowedPets;
        data["chargePets"] = this.chargePets;
        return data;
    }

    clone(): HostToolsPetPolicy {
        const json = this.toJSON();
        let result = new HostToolsPetPolicy();
        result.init(json);
        return result;
    }
}

export interface IHostToolsPetPolicy {
    allowedPets?: string | undefined;
    chargePets?: string | undefined;
}

export class HostToolsImage implements IHostToolsImage {
    id?: string | undefined;
    url?: string | undefined;
    thumbnail_url?: string | undefined;
    caption?: string | undefined;
    sort_order?: number;

    constructor(data?: IHostToolsImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.url = _data["url"];
            this.thumbnail_url = _data["thumbnail_url"];
            this.caption = _data["caption"];
            this.sort_order = _data["sort_order"];
        }
    }

    static fromJS(data: any): HostToolsImage {
        data = typeof data === 'object' ? data : {};
        let result = new HostToolsImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["url"] = this.url;
        data["thumbnail_url"] = this.thumbnail_url;
        data["caption"] = this.caption;
        data["sort_order"] = this.sort_order;
        return data;
    }

    clone(): HostToolsImage {
        const json = this.toJSON();
        let result = new HostToolsImage();
        result.init(json);
        return result;
    }
}

export interface IHostToolsImage {
    id?: string | undefined;
    url?: string | undefined;
    thumbnail_url?: string | undefined;
    caption?: string | undefined;
    sort_order?: number;
}

export class HostToolsAttributeWithQuantity implements IHostToolsAttributeWithQuantity {
    attribute?: string | undefined;
    quantity?: number | undefined;

    constructor(data?: IHostToolsAttributeWithQuantity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attribute = _data["attribute"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): HostToolsAttributeWithQuantity {
        data = typeof data === 'object' ? data : {};
        let result = new HostToolsAttributeWithQuantity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attribute"] = this.attribute;
        data["quantity"] = this.quantity;
        return data;
    }

    clone(): HostToolsAttributeWithQuantity {
        const json = this.toJSON();
        let result = new HostToolsAttributeWithQuantity();
        result.init(json);
        return result;
    }
}

export interface IHostToolsAttributeWithQuantity {
    attribute?: string | undefined;
    quantity?: number | undefined;
}

export class HostToolsBedroomConfiguration implements IHostToolsBedroomConfiguration {
    bedrooms?: HostToolsBedroom[] | undefined;

    constructor(data?: IHostToolsBedroomConfiguration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bedrooms"])) {
                this.bedrooms = [] as any;
                for (let item of _data["bedrooms"])
                    this.bedrooms!.push(HostToolsBedroom.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HostToolsBedroomConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new HostToolsBedroomConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bedrooms)) {
            data["bedrooms"] = [];
            for (let item of this.bedrooms)
                data["bedrooms"].push(item.toJSON());
        }
        return data;
    }

    clone(): HostToolsBedroomConfiguration {
        const json = this.toJSON();
        let result = new HostToolsBedroomConfiguration();
        result.init(json);
        return result;
    }
}

export interface IHostToolsBedroomConfiguration {
    bedrooms?: HostToolsBedroom[] | undefined;
}

export class HostToolsBedroom implements IHostToolsBedroom {
    privateBathroom?: boolean | undefined;
    type?: string | undefined;
    beds?: HostToolsBeds | undefined;

    constructor(data?: IHostToolsBedroom) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.privateBathroom = _data["privateBathroom"];
            this.type = _data["type"];
            this.beds = _data["beds"] ? HostToolsBeds.fromJS(_data["beds"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostToolsBedroom {
        data = typeof data === 'object' ? data : {};
        let result = new HostToolsBedroom();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["privateBathroom"] = this.privateBathroom;
        data["type"] = this.type;
        data["beds"] = this.beds ? this.beds.toJSON() : <any>undefined;
        return data;
    }

    clone(): HostToolsBedroom {
        const json = this.toJSON();
        let result = new HostToolsBedroom();
        result.init(json);
        return result;
    }
}

export interface IHostToolsBedroom {
    privateBathroom?: boolean | undefined;
    type?: string | undefined;
    beds?: HostToolsBeds | undefined;
}

export class HostToolsBeds implements IHostToolsBeds {
    bed?: HostToolsBed[] | undefined;

    constructor(data?: IHostToolsBeds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bed"])) {
                this.bed = [] as any;
                for (let item of _data["bed"])
                    this.bed!.push(HostToolsBed.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HostToolsBeds {
        data = typeof data === 'object' ? data : {};
        let result = new HostToolsBeds();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bed)) {
            data["bed"] = [];
            for (let item of this.bed)
                data["bed"].push(item.toJSON());
        }
        return data;
    }

    clone(): HostToolsBeds {
        const json = this.toJSON();
        let result = new HostToolsBeds();
        result.init(json);
        return result;
    }
}

export interface IHostToolsBeds {
    bed?: HostToolsBed[] | undefined;
}

export class HostToolsBed implements IHostToolsBed {
    count?: number | undefined;
    bedType?: string | undefined;

    constructor(data?: IHostToolsBed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            this.bedType = _data["bedType"];
        }
    }

    static fromJS(data: any): HostToolsBed {
        data = typeof data === 'object' ? data : {};
        let result = new HostToolsBed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["bedType"] = this.bedType;
        return data;
    }

    clone(): HostToolsBed {
        const json = this.toJSON();
        let result = new HostToolsBed();
        result.init(json);
        return result;
    }
}

export interface IHostToolsBed {
    count?: number | undefined;
    bedType?: string | undefined;
}

export class HostToolsPropertyOption implements IHostToolsPropertyOption {
    propertyId?: number;
    name?: string;
    internalName?: string | undefined;
    status?: PropertyStatus;
    isLinked?: boolean;
    linkedListingId?: string | undefined;

    constructor(data?: IHostToolsPropertyOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.propertyId = _data["PropertyId"];
            this.name = _data["Name"];
            this.internalName = _data["InternalName"];
            this.status = _data["Status"];
            this.isLinked = _data["IsLinked"];
            this.linkedListingId = _data["LinkedListingId"];
        }
    }

    static fromJS(data: any): HostToolsPropertyOption {
        data = typeof data === 'object' ? data : {};
        let result = new HostToolsPropertyOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PropertyId"] = this.propertyId;
        data["Name"] = this.name;
        data["InternalName"] = this.internalName;
        data["Status"] = this.status;
        data["IsLinked"] = this.isLinked;
        data["LinkedListingId"] = this.linkedListingId;
        return data;
    }

    clone(): HostToolsPropertyOption {
        const json = this.toJSON();
        let result = new HostToolsPropertyOption();
        result.init(json);
        return result;
    }
}

export interface IHostToolsPropertyOption {
    propertyId?: number;
    name?: string;
    internalName?: string | undefined;
    status?: PropertyStatus;
    isLinked?: boolean;
    linkedListingId?: string | undefined;
}

export class DataListResultOfInventoryAssignmentListModel implements IDataListResultOfInventoryAssignmentListModel {
    items?: InventoryAssignmentListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfInventoryAssignmentListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(InventoryAssignmentListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfInventoryAssignmentListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfInventoryAssignmentListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfInventoryAssignmentListModel {
        const json = this.toJSON();
        let result = new DataListResultOfInventoryAssignmentListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfInventoryAssignmentListModel {
    items?: InventoryAssignmentListModel[] | undefined;
    count?: number;
}

export class InventoryAssignmentListModel implements IInventoryAssignmentListModel {
    id?: number;
    name?: string | undefined;
    category?: string | undefined;
    qty?: number;
    itemId?: number;
    itemName?: string | undefined;
    inventoryAssignmentsType?: string | undefined;
    inventoryAssignmentsBedType?: string | undefined;
    replaceInterval?: number | undefined;
    intervalType?: string | undefined;
    addForAllProperties?: boolean;
    createdAt?: moment.Moment;

    constructor(data?: IInventoryAssignmentListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.category = _data["Category"];
            this.qty = _data["Qty"];
            this.itemId = _data["ItemId"];
            this.itemName = _data["ItemName"];
            this.inventoryAssignmentsType = _data["InventoryAssignmentsType"];
            this.inventoryAssignmentsBedType = _data["InventoryAssignmentsBedType"];
            this.replaceInterval = _data["ReplaceInterval"];
            this.intervalType = _data["IntervalType"];
            this.addForAllProperties = _data["AddForAllProperties"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): InventoryAssignmentListModel {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryAssignmentListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Category"] = this.category;
        data["Qty"] = this.qty;
        data["ItemId"] = this.itemId;
        data["ItemName"] = this.itemName;
        data["InventoryAssignmentsType"] = this.inventoryAssignmentsType;
        data["InventoryAssignmentsBedType"] = this.inventoryAssignmentsBedType;
        data["ReplaceInterval"] = this.replaceInterval;
        data["IntervalType"] = this.intervalType;
        data["AddForAllProperties"] = this.addForAllProperties;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        return data;
    }

    clone(): InventoryAssignmentListModel {
        const json = this.toJSON();
        let result = new InventoryAssignmentListModel();
        result.init(json);
        return result;
    }
}

export interface IInventoryAssignmentListModel {
    id?: number;
    name?: string | undefined;
    category?: string | undefined;
    qty?: number;
    itemId?: number;
    itemName?: string | undefined;
    inventoryAssignmentsType?: string | undefined;
    inventoryAssignmentsBedType?: string | undefined;
    replaceInterval?: number | undefined;
    intervalType?: string | undefined;
    addForAllProperties?: boolean;
    createdAt?: moment.Moment;
}

export class DataListGetParamsOfInventoryAssignmentListFilters implements IDataListGetParamsOfInventoryAssignmentListFilters {
    filter?: InventoryAssignmentListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfInventoryAssignmentListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? InventoryAssignmentListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfInventoryAssignmentListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfInventoryAssignmentListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfInventoryAssignmentListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfInventoryAssignmentListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfInventoryAssignmentListFilters {
    filter?: InventoryAssignmentListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class InventoryAssignmentListFilters implements IInventoryAssignmentListFilters {
    search?: string | undefined;

    constructor(data?: IInventoryAssignmentListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
        }
    }

    static fromJS(data: any): InventoryAssignmentListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryAssignmentListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        return data;
    }

    clone(): InventoryAssignmentListFilters {
        const json = this.toJSON();
        let result = new InventoryAssignmentListFilters();
        result.init(json);
        return result;
    }
}

export interface IInventoryAssignmentListFilters {
    search?: string | undefined;
}

export abstract class InventoryAssignmentBaseModel implements IInventoryAssignmentBaseModel {
    name?: string | undefined;
    category?: InventoryItemCategoryType;
    qty?: number;
    replaceInterval?: number | undefined;
    intervalType?: InventoryAssignmentIntervalType | undefined;
    addForAllProperties?: boolean;

    constructor(data?: IInventoryAssignmentBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.category = _data["Category"];
            this.qty = _data["Qty"];
            this.replaceInterval = _data["ReplaceInterval"];
            this.intervalType = _data["IntervalType"];
            this.addForAllProperties = _data["AddForAllProperties"];
        }
    }

    static fromJS(data: any): InventoryAssignmentBaseModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'InventoryAssignmentBaseModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Category"] = this.category;
        data["Qty"] = this.qty;
        data["ReplaceInterval"] = this.replaceInterval;
        data["IntervalType"] = this.intervalType;
        data["AddForAllProperties"] = this.addForAllProperties;
        return data;
    }

    clone(): InventoryAssignmentBaseModel {
        throw new Error("The abstract class 'InventoryAssignmentBaseModel' cannot be instantiated.");
    }
}

export interface IInventoryAssignmentBaseModel {
    name?: string | undefined;
    category?: InventoryItemCategoryType;
    qty?: number;
    replaceInterval?: number | undefined;
    intervalType?: InventoryAssignmentIntervalType | undefined;
    addForAllProperties?: boolean;
}

export class InventoryAssignmentNewModel extends InventoryAssignmentBaseModel implements IInventoryAssignmentNewModel {
    itemId?: number;
    inventoryAssignmentsType?: InventoryAssignmentType;
    inventoryAssignmentsBedType?: PropertySleepingArrangementBedType | undefined;

    constructor(data?: IInventoryAssignmentNewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.itemId = _data["ItemId"];
            this.inventoryAssignmentsType = _data["InventoryAssignmentsType"];
            this.inventoryAssignmentsBedType = _data["InventoryAssignmentsBedType"];
        }
    }

    static override fromJS(data: any): InventoryAssignmentNewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryAssignmentNewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ItemId"] = this.itemId;
        data["InventoryAssignmentsType"] = this.inventoryAssignmentsType;
        data["InventoryAssignmentsBedType"] = this.inventoryAssignmentsBedType;
        super.toJSON(data);
        return data;
    }

    clone(): InventoryAssignmentNewModel {
        const json = this.toJSON();
        let result = new InventoryAssignmentNewModel();
        result.init(json);
        return result;
    }
}

export interface IInventoryAssignmentNewModel extends IInventoryAssignmentBaseModel {
    itemId?: number;
    inventoryAssignmentsType?: InventoryAssignmentType;
    inventoryAssignmentsBedType?: PropertySleepingArrangementBedType | undefined;
}

/** 1 = Unit 2 = PerGuest 3 = PerBathroom 4 = PerBedType */
export enum InventoryAssignmentType {
    Unit = 1,
    PerGuest = 2,
    PerBathroom = 3,
    PerBedType = 4,
}

/** 1 = Single 2 = Twin 3 = Full 4 = Queen 5 = King 6 = CaliforniaKing 7 = BunkBed 8 = SofaBed 9 = Futon 10 = Crib 11 = ToddlerBed 12 = AirMattressQueen 13 = AirMattressKing 14 = AirMattressTwin */
export enum PropertySleepingArrangementBedType {
    Single = 1,
    Twin = 2,
    Full = 3,
    Queen = 4,
    King = 5,
    CaliforniaKing = 6,
    BunkBed = 7,
    SofaBed = 8,
    Futon = 9,
    Crib = 10,
    ToddlerBed = 11,
    AirMattressQueen = 12,
    AirMattressKing = 13,
    AirMattressTwin = 14,
}

/** 1 = Kitchen 2 = Bedroom 3 = Living 4 = Bathroom 5 = General */
export enum InventoryItemCategoryType {
    Kitchen = 1,
    Bedroom = 2,
    Living = 3,
    Bathroom = 4,
    General = 5,
}

/** 1 = Day 2 = Week 3 = Month 4 = Year */
export enum InventoryAssignmentIntervalType {
    Day = 1,
    Week = 2,
    Month = 3,
    Year = 4,
}

export class InventoryAssignmentEditModel extends InventoryAssignmentBaseModel implements IInventoryAssignmentEditModel {
    id?: number;

    constructor(data?: IInventoryAssignmentEditModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
        }
    }

    static override fromJS(data: any): InventoryAssignmentEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryAssignmentEditModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        super.toJSON(data);
        return data;
    }

    clone(): InventoryAssignmentEditModel {
        const json = this.toJSON();
        let result = new InventoryAssignmentEditModel();
        result.init(json);
        return result;
    }
}

export interface IInventoryAssignmentEditModel extends IInventoryAssignmentBaseModel {
    id?: number;
}

export class InventoryAssignmentDetailsModel extends InventoryAssignmentBaseModel implements IInventoryAssignmentDetailsModel {
    id?: number;
    itemName?: string | undefined;
    itemId?: number;
    inventoryAssignmentsType?: InventoryAssignmentType;
    inventoryAssignmentsBedType?: PropertySleepingArrangementBedType | undefined;

    constructor(data?: IInventoryAssignmentDetailsModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.itemName = _data["ItemName"];
            this.itemId = _data["ItemId"];
            this.inventoryAssignmentsType = _data["InventoryAssignmentsType"];
            this.inventoryAssignmentsBedType = _data["InventoryAssignmentsBedType"];
        }
    }

    static override fromJS(data: any): InventoryAssignmentDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryAssignmentDetailsModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ItemName"] = this.itemName;
        data["ItemId"] = this.itemId;
        data["InventoryAssignmentsType"] = this.inventoryAssignmentsType;
        data["InventoryAssignmentsBedType"] = this.inventoryAssignmentsBedType;
        super.toJSON(data);
        return data;
    }

    clone(): InventoryAssignmentDetailsModel {
        const json = this.toJSON();
        let result = new InventoryAssignmentDetailsModel();
        result.init(json);
        return result;
    }
}

export interface IInventoryAssignmentDetailsModel extends IInventoryAssignmentBaseModel {
    id?: number;
    itemName?: string | undefined;
    itemId?: number;
    inventoryAssignmentsType?: InventoryAssignmentType;
    inventoryAssignmentsBedType?: PropertySleepingArrangementBedType | undefined;
}

export class DataListResultOfInventoryItemListModel implements IDataListResultOfInventoryItemListModel {
    items?: InventoryItemListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfInventoryItemListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(InventoryItemListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfInventoryItemListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfInventoryItemListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfInventoryItemListModel {
        const json = this.toJSON();
        let result = new DataListResultOfInventoryItemListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfInventoryItemListModel {
    items?: InventoryItemListModel[] | undefined;
    count?: number;
}

export class InventoryItemListModel implements IInventoryItemListModel {
    id?: number;
    name?: string | undefined;
    price?: number;
    minLevel?: number;
    stockQty?: number;
    notes?: string | undefined;
    productLink?: string | undefined;
    unitOfMeasurement?: UnitOfMeasurementType;

    constructor(data?: IInventoryItemListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.price = _data["Price"];
            this.minLevel = _data["MinLevel"];
            this.stockQty = _data["StockQty"];
            this.notes = _data["Notes"];
            this.productLink = _data["ProductLink"];
            this.unitOfMeasurement = _data["UnitOfMeasurement"];
        }
    }

    static fromJS(data: any): InventoryItemListModel {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryItemListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Price"] = this.price;
        data["MinLevel"] = this.minLevel;
        data["StockQty"] = this.stockQty;
        data["Notes"] = this.notes;
        data["ProductLink"] = this.productLink;
        data["UnitOfMeasurement"] = this.unitOfMeasurement;
        return data;
    }

    clone(): InventoryItemListModel {
        const json = this.toJSON();
        let result = new InventoryItemListModel();
        result.init(json);
        return result;
    }
}

export interface IInventoryItemListModel {
    id?: number;
    name?: string | undefined;
    price?: number;
    minLevel?: number;
    stockQty?: number;
    notes?: string | undefined;
    productLink?: string | undefined;
    unitOfMeasurement?: UnitOfMeasurementType;
}

/** 1 = Count */
export enum UnitOfMeasurementType {
    Count = 1,
}

export class DataListGetParamsOfInventoryItemListFilters implements IDataListGetParamsOfInventoryItemListFilters {
    filter?: InventoryItemListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfInventoryItemListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? InventoryItemListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfInventoryItemListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfInventoryItemListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfInventoryItemListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfInventoryItemListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfInventoryItemListFilters {
    filter?: InventoryItemListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class InventoryItemListFilters implements IInventoryItemListFilters {
    search?: string | undefined;

    constructor(data?: IInventoryItemListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
        }
    }

    static fromJS(data: any): InventoryItemListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryItemListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        return data;
    }

    clone(): InventoryItemListFilters {
        const json = this.toJSON();
        let result = new InventoryItemListFilters();
        result.init(json);
        return result;
    }
}

export interface IInventoryItemListFilters {
    search?: string | undefined;
}

export class NamedValueLong implements INamedValueLong {
    id?: number;
    name?: string | undefined;

    constructor(data?: INamedValueLong) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
        }
    }

    static fromJS(data: any): NamedValueLong {
        data = typeof data === 'object' ? data : {};
        let result = new NamedValueLong();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        return data;
    }

    clone(): NamedValueLong {
        const json = this.toJSON();
        let result = new NamedValueLong();
        result.init(json);
        return result;
    }
}

export interface INamedValueLong {
    id?: number;
    name?: string | undefined;
}

export abstract class InventoryItemBaseModel implements IInventoryItemBaseModel {
    name?: string | undefined;
    price?: number;
    minLevel?: number;
    notes?: string | undefined;
    productLink?: string | undefined;

    constructor(data?: IInventoryItemBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["Name"];
            this.price = _data["Price"];
            this.minLevel = _data["MinLevel"];
            this.notes = _data["Notes"];
            this.productLink = _data["ProductLink"];
        }
    }

    static fromJS(data: any): InventoryItemBaseModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'InventoryItemBaseModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Name"] = this.name;
        data["Price"] = this.price;
        data["MinLevel"] = this.minLevel;
        data["Notes"] = this.notes;
        data["ProductLink"] = this.productLink;
        return data;
    }

    clone(): InventoryItemBaseModel {
        throw new Error("The abstract class 'InventoryItemBaseModel' cannot be instantiated.");
    }
}

export interface IInventoryItemBaseModel {
    name?: string | undefined;
    price?: number;
    minLevel?: number;
    notes?: string | undefined;
    productLink?: string | undefined;
}

export class InventoryItemDetailsModel extends InventoryItemBaseModel implements IInventoryItemDetailsModel {
    id?: number;
    stockQty?: number;
    unitOfMeasurement?: UnitOfMeasurementType;

    constructor(data?: IInventoryItemDetailsModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
            this.stockQty = _data["StockQty"];
            this.unitOfMeasurement = _data["UnitOfMeasurement"];
        }
    }

    static override fromJS(data: any): InventoryItemDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryItemDetailsModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["StockQty"] = this.stockQty;
        data["UnitOfMeasurement"] = this.unitOfMeasurement;
        super.toJSON(data);
        return data;
    }

    clone(): InventoryItemDetailsModel {
        const json = this.toJSON();
        let result = new InventoryItemDetailsModel();
        result.init(json);
        return result;
    }
}

export interface IInventoryItemDetailsModel extends IInventoryItemBaseModel {
    id?: number;
    stockQty?: number;
    unitOfMeasurement?: UnitOfMeasurementType;
}

export class InventoryItemNewModel extends InventoryItemBaseModel implements IInventoryItemNewModel {
    stockQty?: number;
    unitOfMeasurement?: UnitOfMeasurementType;

    constructor(data?: IInventoryItemNewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.stockQty = _data["StockQty"];
            this.unitOfMeasurement = _data["UnitOfMeasurement"];
        }
    }

    static override fromJS(data: any): InventoryItemNewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryItemNewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StockQty"] = this.stockQty;
        data["UnitOfMeasurement"] = this.unitOfMeasurement;
        super.toJSON(data);
        return data;
    }

    clone(): InventoryItemNewModel {
        const json = this.toJSON();
        let result = new InventoryItemNewModel();
        result.init(json);
        return result;
    }
}

export interface IInventoryItemNewModel extends IInventoryItemBaseModel {
    stockQty?: number;
    unitOfMeasurement?: UnitOfMeasurementType;
}

export class InventoryItemEditModel extends InventoryItemBaseModel implements IInventoryItemEditModel {
    id?: number;

    constructor(data?: IInventoryItemEditModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["Id"];
        }
    }

    static override fromJS(data: any): InventoryItemEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryItemEditModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        super.toJSON(data);
        return data;
    }

    clone(): InventoryItemEditModel {
        const json = this.toJSON();
        let result = new InventoryItemEditModel();
        result.init(json);
        return result;
    }
}

export interface IInventoryItemEditModel extends IInventoryItemBaseModel {
    id?: number;
}

export class InventoryItemUpdateStockModel implements IInventoryItemUpdateStockModel {
    id?: number;
    changeQty?: number;
    notes?: string | undefined;

    constructor(data?: IInventoryItemUpdateStockModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.changeQty = _data["ChangeQty"];
            this.notes = _data["Notes"];
        }
    }

    static fromJS(data: any): InventoryItemUpdateStockModel {
        data = typeof data === 'object' ? data : {};
        let result = new InventoryItemUpdateStockModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ChangeQty"] = this.changeQty;
        data["Notes"] = this.notes;
        return data;
    }

    clone(): InventoryItemUpdateStockModel {
        const json = this.toJSON();
        let result = new InventoryItemUpdateStockModel();
        result.init(json);
        return result;
    }
}

export interface IInventoryItemUpdateStockModel {
    id?: number;
    changeQty?: number;
    notes?: string | undefined;
}

export class PolicyEditModel implements IPolicyEditModel {
    id?: number | undefined;
    name?: string | undefined;
    type?: PolicyType;
    policy?: string | undefined;

    constructor(data?: IPolicyEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.policy = _data["Policy"];
        }
    }

    static fromJS(data: any): PolicyEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["Policy"] = this.policy;
        return data;
    }

    clone(): PolicyEditModel {
        const json = this.toJSON();
        let result = new PolicyEditModel();
        result.init(json);
        return result;
    }
}

export interface IPolicyEditModel {
    id?: number | undefined;
    name?: string | undefined;
    type?: PolicyType;
    policy?: string | undefined;
}

/** 1 = Stay 2 = Cancel 3 = NoShow 4 = Pets 5 = Other */
export enum PolicyType {
    Stay = 1,
    Cancel = 2,
    NoShow = 3,
    Pets = 4,
    Other = 5,
}

export class DataListResultOfPolicyListModel implements IDataListResultOfPolicyListModel {
    items?: PolicyListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfPolicyListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(PolicyListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfPolicyListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfPolicyListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfPolicyListModel {
        const json = this.toJSON();
        let result = new DataListResultOfPolicyListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfPolicyListModel {
    items?: PolicyListModel[] | undefined;
    count?: number;
}

export class PolicyListModel implements IPolicyListModel {
    id?: number;
    name?: string | undefined;
    type?: PolicyType;
    text?: string | undefined;

    constructor(data?: IPolicyListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.text = _data["Text"];
        }
    }

    static fromJS(data: any): PolicyListModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["Text"] = this.text;
        return data;
    }

    clone(): PolicyListModel {
        const json = this.toJSON();
        let result = new PolicyListModel();
        result.init(json);
        return result;
    }
}

export interface IPolicyListModel {
    id?: number;
    name?: string | undefined;
    type?: PolicyType;
    text?: string | undefined;
}

export class DataListGetParamsOfPolicyListFilters implements IDataListGetParamsOfPolicyListFilters {
    filter?: PolicyListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfPolicyListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? PolicyListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfPolicyListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfPolicyListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfPolicyListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfPolicyListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfPolicyListFilters {
    filter?: PolicyListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class PolicyListFilters implements IPolicyListFilters {
    search?: string | undefined;

    constructor(data?: IPolicyListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
        }
    }

    static fromJS(data: any): PolicyListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        return data;
    }

    clone(): PolicyListFilters {
        const json = this.toJSON();
        let result = new PolicyListFilters();
        result.init(json);
        return result;
    }
}

export interface IPolicyListFilters {
    search?: string | undefined;
}

export class PolicyShortListModel implements IPolicyShortListModel {
    id?: number;
    type?: PolicyType;
    name?: string | undefined;
    text?: string | undefined;

    constructor(data?: IPolicyShortListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.type = _data["Type"];
            this.name = _data["Name"];
            this.text = _data["Text"];
        }
    }

    static fromJS(data: any): PolicyShortListModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyShortListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Type"] = this.type;
        data["Name"] = this.name;
        data["Text"] = this.text;
        return data;
    }

    clone(): PolicyShortListModel {
        const json = this.toJSON();
        let result = new PolicyShortListModel();
        result.init(json);
        return result;
    }
}

export interface IPolicyShortListModel {
    id?: number;
    type?: PolicyType;
    name?: string | undefined;
    text?: string | undefined;
}

export class PolicyShortListFilters implements IPolicyShortListFilters {
    type?: PolicyType;

    constructor(data?: IPolicyShortListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): PolicyShortListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyShortListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        return data;
    }

    clone(): PolicyShortListFilters {
        const json = this.toJSON();
        let result = new PolicyShortListFilters();
        result.init(json);
        return result;
    }
}

export interface IPolicyShortListFilters {
    type?: PolicyType;
}

export class PolicyModel implements IPolicyModel {
    id?: number;
    name?: string | undefined;
    type?: PolicyType;
    policy?: string | undefined;

    constructor(data?: IPolicyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.policy = _data["Policy"];
        }
    }

    static fromJS(data: any): PolicyModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["Policy"] = this.policy;
        return data;
    }

    clone(): PolicyModel {
        const json = this.toJSON();
        let result = new PolicyModel();
        result.init(json);
        return result;
    }
}

export interface IPolicyModel {
    id?: number;
    name?: string | undefined;
    type?: PolicyType;
    policy?: string | undefined;
}

export class PolicyStay implements IPolicyStay {
    checkInTimeFrom?: number;
    checkInTimeTo?: number | undefined;
    checkOutTimeFrom?: number;
    checkOutTimeTo?: number | undefined;
    guestType?: AcceptedGuestType;

    constructor(data?: IPolicyStay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkInTimeFrom = _data["CheckInTimeFrom"];
            this.checkInTimeTo = _data["CheckInTimeTo"];
            this.checkOutTimeFrom = _data["CheckOutTimeFrom"];
            this.checkOutTimeTo = _data["CheckOutTimeTo"];
            this.guestType = _data["GuestType"];
        }
    }

    static fromJS(data: any): PolicyStay {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyStay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["CheckInTimeFrom"] = this.checkInTimeFrom;
        data["CheckInTimeTo"] = this.checkInTimeTo;
        data["CheckOutTimeFrom"] = this.checkOutTimeFrom;
        data["CheckOutTimeTo"] = this.checkOutTimeTo;
        data["GuestType"] = this.guestType;
        return data;
    }

    clone(): PolicyStay {
        const json = this.toJSON();
        let result = new PolicyStay();
        result.init(json);
        return result;
    }
}

export interface IPolicyStay {
    checkInTimeFrom?: number;
    checkInTimeTo?: number | undefined;
    checkOutTimeFrom?: number;
    checkOutTimeTo?: number | undefined;
    guestType?: AcceptedGuestType;
}

/** 1 = AdultOnly 2 = ChildrenAllowed */
export enum AcceptedGuestType {
    AdultOnly = 1,
    ChildrenAllowed = 2,
}

export class PolicyCancel implements IPolicyCancel {
    penaltyAfterReservation?: number | undefined;
    penaltyAfterReservationType?: CancelPolicyChargeType;
    deadlineDays?: number | undefined;
    penaltyAfterDeadline?: number | undefined;
    penaltyAfterDeadlineType?: CancelPolicyChargeType;

    constructor(data?: IPolicyCancel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.penaltyAfterReservation = _data["PenaltyAfterReservation"];
            this.penaltyAfterReservationType = _data["PenaltyAfterReservationType"];
            this.deadlineDays = _data["DeadlineDays"];
            this.penaltyAfterDeadline = _data["PenaltyAfterDeadline"];
            this.penaltyAfterDeadlineType = _data["PenaltyAfterDeadlineType"];
        }
    }

    static fromJS(data: any): PolicyCancel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyCancel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PenaltyAfterReservation"] = this.penaltyAfterReservation;
        data["PenaltyAfterReservationType"] = this.penaltyAfterReservationType;
        data["DeadlineDays"] = this.deadlineDays;
        data["PenaltyAfterDeadline"] = this.penaltyAfterDeadline;
        data["PenaltyAfterDeadlineType"] = this.penaltyAfterDeadlineType;
        return data;
    }

    clone(): PolicyCancel {
        const json = this.toJSON();
        let result = new PolicyCancel();
        result.init(json);
        return result;
    }
}

export interface IPolicyCancel {
    penaltyAfterReservation?: number | undefined;
    penaltyAfterReservationType?: CancelPolicyChargeType;
    deadlineDays?: number | undefined;
    penaltyAfterDeadline?: number | undefined;
    penaltyAfterDeadlineType?: CancelPolicyChargeType;
}

/** 1 = Percentage 2 = Night */
export enum CancelPolicyChargeType {
    Percentage = 1,
    Night = 2,
}

export class PolicyNoShow implements IPolicyNoShow {
    penaltyPercentage?: number;

    constructor(data?: IPolicyNoShow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.penaltyPercentage = _data["PenaltyPercentage"];
        }
    }

    static fromJS(data: any): PolicyNoShow {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyNoShow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PenaltyPercentage"] = this.penaltyPercentage;
        return data;
    }

    clone(): PolicyNoShow {
        const json = this.toJSON();
        let result = new PolicyNoShow();
        result.init(json);
        return result;
    }
}

export interface IPolicyNoShow {
    penaltyPercentage?: number;
}

export class PolicyPets implements IPolicyPets {
    type?: PolicyPetsType;

    constructor(data?: IPolicyPets) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["Type"];
        }
    }

    static fromJS(data: any): PolicyPets {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyPets();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type;
        return data;
    }

    clone(): PolicyPets {
        const json = this.toJSON();
        let result = new PolicyPets();
        result.init(json);
        return result;
    }
}

export interface IPolicyPets {
    type?: PolicyPetsType;
}

/** 1 = Free 2 = ChargesMayApply 3 = NotAllowed */
export enum PolicyPetsType {
    Free = 1,
    ChargesMayApply = 2,
    NotAllowed = 3,
}

export class PolicyOther implements IPolicyOther {
    text?: string | undefined;

    constructor(data?: IPolicyOther) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["Text"];
        }
    }

    static fromJS(data: any): PolicyOther {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyOther();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Text"] = this.text;
        return data;
    }

    clone(): PolicyOther {
        const json = this.toJSON();
        let result = new PolicyOther();
        result.init(json);
        return result;
    }
}

export interface IPolicyOther {
    text?: string | undefined;
}

export class PolicyStringPreviewModel implements IPolicyStringPreviewModel {
    type?: PolicyType;
    policy?: string | undefined;

    constructor(data?: IPolicyStringPreviewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["Type"];
            this.policy = _data["Policy"];
        }
    }

    static fromJS(data: any): PolicyStringPreviewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyStringPreviewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type;
        data["Policy"] = this.policy;
        return data;
    }

    clone(): PolicyStringPreviewModel {
        const json = this.toJSON();
        let result = new PolicyStringPreviewModel();
        result.init(json);
        return result;
    }
}

export interface IPolicyStringPreviewModel {
    type?: PolicyType;
    policy?: string | undefined;
}

export class PropertyAmenityEditModel implements IPropertyAmenityEditModel {
    id?: number | undefined;
    name?: string | undefined;
    active?: boolean;

    constructor(data?: IPropertyAmenityEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.active = _data["Active"];
        }
    }

    static fromJS(data: any): PropertyAmenityEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyAmenityEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Active"] = this.active;
        return data;
    }

    clone(): PropertyAmenityEditModel {
        const json = this.toJSON();
        let result = new PropertyAmenityEditModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyAmenityEditModel {
    id?: number | undefined;
    name?: string | undefined;
    active?: boolean;
}

export class DataListResultOfPropertyAmenityListModel implements IDataListResultOfPropertyAmenityListModel {
    items?: PropertyAmenityListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfPropertyAmenityListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(PropertyAmenityListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfPropertyAmenityListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfPropertyAmenityListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfPropertyAmenityListModel {
        const json = this.toJSON();
        let result = new DataListResultOfPropertyAmenityListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfPropertyAmenityListModel {
    items?: PropertyAmenityListModel[] | undefined;
    count?: number;
}

export class PropertyAmenityListModel implements IPropertyAmenityListModel {
    id?: number;
    name?: string | undefined;
    active?: boolean;

    constructor(data?: IPropertyAmenityListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.active = _data["Active"];
        }
    }

    static fromJS(data: any): PropertyAmenityListModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyAmenityListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Active"] = this.active;
        return data;
    }

    clone(): PropertyAmenityListModel {
        const json = this.toJSON();
        let result = new PropertyAmenityListModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyAmenityListModel {
    id?: number;
    name?: string | undefined;
    active?: boolean;
}

export class DataListGetParamsOfPropertyAmenityListFilters implements IDataListGetParamsOfPropertyAmenityListFilters {
    filter?: PropertyAmenityListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfPropertyAmenityListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? PropertyAmenityListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfPropertyAmenityListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfPropertyAmenityListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfPropertyAmenityListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfPropertyAmenityListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfPropertyAmenityListFilters {
    filter?: PropertyAmenityListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class PropertyAmenityListFilters implements IPropertyAmenityListFilters {
    search?: string | undefined;

    constructor(data?: IPropertyAmenityListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
        }
    }

    static fromJS(data: any): PropertyAmenityListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyAmenityListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        return data;
    }

    clone(): PropertyAmenityListFilters {
        const json = this.toJSON();
        let result = new PropertyAmenityListFilters();
        result.init(json);
        return result;
    }
}

export interface IPropertyAmenityListFilters {
    search?: string | undefined;
}

export class PropertyAmenityShortListModel implements IPropertyAmenityShortListModel {
    id?: number;
    name?: string | undefined;
    active?: boolean;

    constructor(data?: IPropertyAmenityShortListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.active = _data["Active"];
        }
    }

    static fromJS(data: any): PropertyAmenityShortListModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyAmenityShortListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Active"] = this.active;
        return data;
    }

    clone(): PropertyAmenityShortListModel {
        const json = this.toJSON();
        let result = new PropertyAmenityShortListModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyAmenityShortListModel {
    id?: number;
    name?: string | undefined;
    active?: boolean;
}

export class PropertyAmenityModel extends PropertyAmenityListModel implements IPropertyAmenityModel {

    constructor(data?: IPropertyAmenityModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PropertyAmenityModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyAmenityModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): PropertyAmenityModel {
        const json = this.toJSON();
        let result = new PropertyAmenityModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyAmenityModel extends IPropertyAmenityListModel {
}

export class PropertyContactEditModel implements IPropertyContactEditModel {
    id?: number | undefined;
    name?: string | undefined;
    email?: string | undefined;
    phone?: number;
    note?: string | undefined;

    constructor(data?: IPropertyContactEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.email = _data["Email"];
            this.phone = _data["Phone"];
            this.note = _data["Note"];
        }
    }

    static fromJS(data: any): PropertyContactEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyContactEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Email"] = this.email;
        data["Phone"] = this.phone;
        data["Note"] = this.note;
        return data;
    }

    clone(): PropertyContactEditModel {
        const json = this.toJSON();
        let result = new PropertyContactEditModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyContactEditModel {
    id?: number | undefined;
    name?: string | undefined;
    email?: string | undefined;
    phone?: number;
    note?: string | undefined;
}

export class DataListResultOfPropertyContactListModel implements IDataListResultOfPropertyContactListModel {
    items?: PropertyContactListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfPropertyContactListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(PropertyContactListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfPropertyContactListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfPropertyContactListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfPropertyContactListModel {
        const json = this.toJSON();
        let result = new DataListResultOfPropertyContactListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfPropertyContactListModel {
    items?: PropertyContactListModel[] | undefined;
    count?: number;
}

export class PropertyContactListModel implements IPropertyContactListModel {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    phone?: number;
    note?: string | undefined;

    constructor(data?: IPropertyContactListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.email = _data["Email"];
            this.phone = _data["Phone"];
            this.note = _data["Note"];
        }
    }

    static fromJS(data: any): PropertyContactListModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyContactListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Email"] = this.email;
        data["Phone"] = this.phone;
        data["Note"] = this.note;
        return data;
    }

    clone(): PropertyContactListModel {
        const json = this.toJSON();
        let result = new PropertyContactListModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyContactListModel {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    phone?: number;
    note?: string | undefined;
}

export class DataListGetParamsOfPropertyContactListFilters implements IDataListGetParamsOfPropertyContactListFilters {
    filter?: PropertyContactListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfPropertyContactListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? PropertyContactListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfPropertyContactListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfPropertyContactListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfPropertyContactListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfPropertyContactListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfPropertyContactListFilters {
    filter?: PropertyContactListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class PropertyContactListFilters implements IPropertyContactListFilters {
    search?: string | undefined;

    constructor(data?: IPropertyContactListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
        }
    }

    static fromJS(data: any): PropertyContactListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyContactListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        return data;
    }

    clone(): PropertyContactListFilters {
        const json = this.toJSON();
        let result = new PropertyContactListFilters();
        result.init(json);
        return result;
    }
}

export interface IPropertyContactListFilters {
    search?: string | undefined;
}

export class PropertyContactShortListModel implements IPropertyContactShortListModel {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    phone?: number;

    constructor(data?: IPropertyContactShortListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.email = _data["Email"];
            this.phone = _data["Phone"];
        }
    }

    static fromJS(data: any): PropertyContactShortListModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyContactShortListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Email"] = this.email;
        data["Phone"] = this.phone;
        return data;
    }

    clone(): PropertyContactShortListModel {
        const json = this.toJSON();
        let result = new PropertyContactShortListModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyContactShortListModel {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    phone?: number;
}

export class PropertyContactModel extends PropertyContactListModel implements IPropertyContactModel {

    constructor(data?: IPropertyContactModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PropertyContactModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyContactModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): PropertyContactModel {
        const json = this.toJSON();
        let result = new PropertyContactModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyContactModel extends IPropertyContactListModel {
}

export class PropertyDetails implements IPropertyDetails {
    id?: number;
    name?: string | undefined;
    internalName?: string | undefined;
    description?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    zipCode?: string | undefined;
    latitude?: number;
    longitude?: number;
    showAddressBeforeDays?: number | undefined;
    defaultRate?: number;
    type?: PropertyType;
    status?: PropertyStatus;
    thumbnailImageId?: number | undefined;
    petMax?: number;
    bathrooms?: number;
    minNights?: number;
    amenities?: number[] | undefined;
    policies?: PolicyShortListModel[] | undefined;
    sleepingArrangements?: PropertySleepingArrangement[] | undefined;
    maxNights?: number | undefined;
    quietHoursStartTime?: number | undefined;
    quietHoursEndTime?: number | undefined;
    quietHoursEnabled?: boolean;
    partiesAllowed?: boolean;
    smokingAllowed?: boolean;
    maxGuests?: number | undefined;
    contactId?: number | undefined;
    houseRules?: string | undefined;
    checkInCheckOutInstructions?: string | undefined;
    isTest?: boolean;

    constructor(data?: IPropertyDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.internalName = _data["InternalName"];
            this.description = _data["Description"];
            this.state = _data["State"];
            this.city = _data["City"];
            this.address1 = _data["Address1"];
            this.address2 = _data["Address2"];
            this.zipCode = _data["ZipCode"];
            this.latitude = _data["Latitude"];
            this.longitude = _data["Longitude"];
            this.showAddressBeforeDays = _data["ShowAddressBeforeDays"];
            this.defaultRate = _data["DefaultRate"];
            this.type = _data["Type"];
            this.status = _data["Status"];
            this.thumbnailImageId = _data["ThumbnailImageId"];
            this.petMax = _data["PetMax"];
            this.bathrooms = _data["Bathrooms"];
            this.minNights = _data["MinNights"];
            if (Array.isArray(_data["Amenities"])) {
                this.amenities = [] as any;
                for (let item of _data["Amenities"])
                    this.amenities!.push(item);
            }
            if (Array.isArray(_data["Policies"])) {
                this.policies = [] as any;
                for (let item of _data["Policies"])
                    this.policies!.push(PolicyShortListModel.fromJS(item));
            }
            if (Array.isArray(_data["SleepingArrangements"])) {
                this.sleepingArrangements = [] as any;
                for (let item of _data["SleepingArrangements"])
                    this.sleepingArrangements!.push(PropertySleepingArrangement.fromJS(item));
            }
            this.maxNights = _data["MaxNights"];
            this.quietHoursStartTime = _data["QuietHoursStartTime"];
            this.quietHoursEndTime = _data["QuietHoursEndTime"];
            this.quietHoursEnabled = _data["QuietHoursEnabled"];
            this.partiesAllowed = _data["PartiesAllowed"];
            this.smokingAllowed = _data["SmokingAllowed"];
            this.maxGuests = _data["MaxGuests"];
            this.contactId = _data["ContactId"];
            this.houseRules = _data["HouseRules"];
            this.checkInCheckOutInstructions = _data["CheckInCheckOutInstructions"];
            this.isTest = _data["IsTest"];
        }
    }

    static fromJS(data: any): PropertyDetails {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["InternalName"] = this.internalName;
        data["Description"] = this.description;
        data["State"] = this.state;
        data["City"] = this.city;
        data["Address1"] = this.address1;
        data["Address2"] = this.address2;
        data["ZipCode"] = this.zipCode;
        data["Latitude"] = this.latitude;
        data["Longitude"] = this.longitude;
        data["ShowAddressBeforeDays"] = this.showAddressBeforeDays;
        data["DefaultRate"] = this.defaultRate;
        data["Type"] = this.type;
        data["Status"] = this.status;
        data["ThumbnailImageId"] = this.thumbnailImageId;
        data["PetMax"] = this.petMax;
        data["Bathrooms"] = this.bathrooms;
        data["MinNights"] = this.minNights;
        if (Array.isArray(this.amenities)) {
            data["Amenities"] = [];
            for (let item of this.amenities)
                data["Amenities"].push(item);
        }
        if (Array.isArray(this.policies)) {
            data["Policies"] = [];
            for (let item of this.policies)
                data["Policies"].push(item.toJSON());
        }
        if (Array.isArray(this.sleepingArrangements)) {
            data["SleepingArrangements"] = [];
            for (let item of this.sleepingArrangements)
                data["SleepingArrangements"].push(item.toJSON());
        }
        data["MaxNights"] = this.maxNights;
        data["QuietHoursStartTime"] = this.quietHoursStartTime;
        data["QuietHoursEndTime"] = this.quietHoursEndTime;
        data["QuietHoursEnabled"] = this.quietHoursEnabled;
        data["PartiesAllowed"] = this.partiesAllowed;
        data["SmokingAllowed"] = this.smokingAllowed;
        data["MaxGuests"] = this.maxGuests;
        data["ContactId"] = this.contactId;
        data["HouseRules"] = this.houseRules;
        data["CheckInCheckOutInstructions"] = this.checkInCheckOutInstructions;
        data["IsTest"] = this.isTest;
        return data;
    }

    clone(): PropertyDetails {
        const json = this.toJSON();
        let result = new PropertyDetails();
        result.init(json);
        return result;
    }
}

export interface IPropertyDetails {
    id?: number;
    name?: string | undefined;
    internalName?: string | undefined;
    description?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    zipCode?: string | undefined;
    latitude?: number;
    longitude?: number;
    showAddressBeforeDays?: number | undefined;
    defaultRate?: number;
    type?: PropertyType;
    status?: PropertyStatus;
    thumbnailImageId?: number | undefined;
    petMax?: number;
    bathrooms?: number;
    minNights?: number;
    amenities?: number[] | undefined;
    policies?: PolicyShortListModel[] | undefined;
    sleepingArrangements?: PropertySleepingArrangement[] | undefined;
    maxNights?: number | undefined;
    quietHoursStartTime?: number | undefined;
    quietHoursEndTime?: number | undefined;
    quietHoursEnabled?: boolean;
    partiesAllowed?: boolean;
    smokingAllowed?: boolean;
    maxGuests?: number | undefined;
    contactId?: number | undefined;
    houseRules?: string | undefined;
    checkInCheckOutInstructions?: string | undefined;
    isTest?: boolean;
}

/** 1 = Apartments 2 = Condo 3 = Duplex 4 = House 5 = Townhouse 6 = Villa 7 = Cabins 8 = Chalets 9 = Cottages */
export enum PropertyType {
    Apartments = 1,
    Condo = 2,
    Duplex = 3,
    House = 4,
    Townhouse = 5,
    Villa = 6,
    Cabins = 7,
    Chalets = 8,
    Cottages = 9,
}

export class PropertySleepingArrangement implements IPropertySleepingArrangement {
    type?: PropertyRoomType;
    beds?: PropertySleepingArrangementBed[] | undefined;

    constructor(data?: IPropertySleepingArrangement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["Type"];
            if (Array.isArray(_data["Beds"])) {
                this.beds = [] as any;
                for (let item of _data["Beds"])
                    this.beds!.push(PropertySleepingArrangementBed.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PropertySleepingArrangement {
        data = typeof data === 'object' ? data : {};
        let result = new PropertySleepingArrangement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type;
        if (Array.isArray(this.beds)) {
            data["Beds"] = [];
            for (let item of this.beds)
                data["Beds"].push(item.toJSON());
        }
        return data;
    }

    clone(): PropertySleepingArrangement {
        const json = this.toJSON();
        let result = new PropertySleepingArrangement();
        result.init(json);
        return result;
    }
}

export interface IPropertySleepingArrangement {
    type?: PropertyRoomType;
    beds?: PropertySleepingArrangementBed[] | undefined;
}

/** 1 = Studio 2 = Bedroom */
export enum PropertyRoomType {
    Studio = 1,
    Bedroom = 2,
}

export class PropertySleepingArrangementBed implements IPropertySleepingArrangementBed {
    type?: PropertySleepingArrangementBedType;
    people?: number;

    constructor(data?: IPropertySleepingArrangementBed) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["Type"];
            this.people = _data["People"];
        }
    }

    static fromJS(data: any): PropertySleepingArrangementBed {
        data = typeof data === 'object' ? data : {};
        let result = new PropertySleepingArrangementBed();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Type"] = this.type;
        data["People"] = this.people;
        return data;
    }

    clone(): PropertySleepingArrangementBed {
        const json = this.toJSON();
        let result = new PropertySleepingArrangementBed();
        result.init(json);
        return result;
    }
}

export interface IPropertySleepingArrangementBed {
    type?: PropertySleepingArrangementBedType;
    people?: number;
}

export class DataListResultOfPropertyListModel implements IDataListResultOfPropertyListModel {
    items?: PropertyListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfPropertyListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(PropertyListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfPropertyListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfPropertyListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfPropertyListModel {
        const json = this.toJSON();
        let result = new DataListResultOfPropertyListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfPropertyListModel {
    items?: PropertyListModel[] | undefined;
    count?: number;
}

export class PropertyListModel implements IPropertyListModel {
    id?: number;
    name?: string | undefined;
    address?: string | undefined;
    owner?: string | undefined;
    rate?: number;
    thumbnailUrl?: string | undefined;
    status?: PropertyStatus;

    constructor(data?: IPropertyListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.address = _data["Address"];
            this.owner = _data["Owner"];
            this.rate = _data["Rate"];
            this.thumbnailUrl = _data["ThumbnailUrl"];
            this.status = _data["Status"];
        }
    }

    static fromJS(data: any): PropertyListModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Address"] = this.address;
        data["Owner"] = this.owner;
        data["Rate"] = this.rate;
        data["ThumbnailUrl"] = this.thumbnailUrl;
        data["Status"] = this.status;
        return data;
    }

    clone(): PropertyListModel {
        const json = this.toJSON();
        let result = new PropertyListModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyListModel {
    id?: number;
    name?: string | undefined;
    address?: string | undefined;
    owner?: string | undefined;
    rate?: number;
    thumbnailUrl?: string | undefined;
    status?: PropertyStatus;
}

export class DataListGetParamsOfPropertyListFilters implements IDataListGetParamsOfPropertyListFilters {
    filter?: PropertyListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfPropertyListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? PropertyListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfPropertyListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfPropertyListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfPropertyListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfPropertyListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfPropertyListFilters {
    filter?: PropertyListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class PropertyListFilters implements IPropertyListFilters {
    search?: string | undefined;

    constructor(data?: IPropertyListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
        }
    }

    static fromJS(data: any): PropertyListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        return data;
    }

    clone(): PropertyListFilters {
        const json = this.toJSON();
        let result = new PropertyListFilters();
        result.init(json);
        return result;
    }
}

export interface IPropertyListFilters {
    search?: string | undefined;
}

export class PropertyShortListModel implements IPropertyShortListModel {
    id?: number;
    name?: string | undefined;
    status?: PropertyStatus;

    constructor(data?: IPropertyShortListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.status = _data["Status"];
        }
    }

    static fromJS(data: any): PropertyShortListModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyShortListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Status"] = this.status;
        return data;
    }

    clone(): PropertyShortListModel {
        const json = this.toJSON();
        let result = new PropertyShortListModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyShortListModel {
    id?: number;
    name?: string | undefined;
    status?: PropertyStatus;
}

export class PropertyShortDetailsModel implements IPropertyShortDetailsModel {
    id?: number;
    name?: string | undefined;
    status?: PropertyStatus;
    rate?: number;

    constructor(data?: IPropertyShortDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.status = _data["Status"];
            this.rate = _data["Rate"];
        }
    }

    static fromJS(data: any): PropertyShortDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyShortDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Status"] = this.status;
        data["Rate"] = this.rate;
        return data;
    }

    clone(): PropertyShortDetailsModel {
        const json = this.toJSON();
        let result = new PropertyShortDetailsModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyShortDetailsModel {
    id?: number;
    name?: string | undefined;
    status?: PropertyStatus;
    rate?: number;
}

export class PropertyEdit implements IPropertyEdit {
    id?: number | undefined;
    name?: string | undefined;
    internalName?: string | undefined;
    description?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    zipCode?: string | undefined;
    latitude?: number;
    longitude?: number;
    defaultRate?: number;
    type?: PropertyType;
    status?: PropertyStatus;
    thumbnailImageId?: number | undefined;
    petMax?: number;
    bathrooms?: number;
    minNights?: number;
    amenities?: number[] | undefined;
    policies?: number[] | undefined;
    sleepingArrangements?: PropertySleepingArrangement[] | undefined;
    showAddressBeforeDays?: number | undefined;
    maxNights?: number | undefined;
    quietHoursStartTime?: number | undefined;
    quietHoursEndTime?: number | undefined;
    quietHoursEnabled?: boolean;
    partiesAllowed?: boolean;
    smokingAllowed?: boolean;
    maxGuests?: number | undefined;
    contactId?: number;
    houseRules?: string | undefined;
    checkInCheckOutInstructions?: string | undefined;
    isTest?: boolean;

    constructor(data?: IPropertyEdit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.internalName = _data["InternalName"];
            this.description = _data["Description"];
            this.state = _data["State"];
            this.city = _data["City"];
            this.address1 = _data["Address1"];
            this.address2 = _data["Address2"];
            this.zipCode = _data["ZipCode"];
            this.latitude = _data["Latitude"];
            this.longitude = _data["Longitude"];
            this.defaultRate = _data["DefaultRate"];
            this.type = _data["Type"];
            this.status = _data["Status"];
            this.thumbnailImageId = _data["ThumbnailImageId"];
            this.petMax = _data["PetMax"];
            this.bathrooms = _data["Bathrooms"];
            this.minNights = _data["MinNights"];
            if (Array.isArray(_data["Amenities"])) {
                this.amenities = [] as any;
                for (let item of _data["Amenities"])
                    this.amenities!.push(item);
            }
            if (Array.isArray(_data["Policies"])) {
                this.policies = [] as any;
                for (let item of _data["Policies"])
                    this.policies!.push(item);
            }
            if (Array.isArray(_data["SleepingArrangements"])) {
                this.sleepingArrangements = [] as any;
                for (let item of _data["SleepingArrangements"])
                    this.sleepingArrangements!.push(PropertySleepingArrangement.fromJS(item));
            }
            this.showAddressBeforeDays = _data["ShowAddressBeforeDays"];
            this.maxNights = _data["MaxNights"];
            this.quietHoursStartTime = _data["QuietHoursStartTime"];
            this.quietHoursEndTime = _data["QuietHoursEndTime"];
            this.quietHoursEnabled = _data["QuietHoursEnabled"];
            this.partiesAllowed = _data["PartiesAllowed"];
            this.smokingAllowed = _data["SmokingAllowed"];
            this.maxGuests = _data["MaxGuests"];
            this.contactId = _data["ContactId"];
            this.houseRules = _data["HouseRules"];
            this.checkInCheckOutInstructions = _data["CheckInCheckOutInstructions"];
            this.isTest = _data["IsTest"];
        }
    }

    static fromJS(data: any): PropertyEdit {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyEdit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["InternalName"] = this.internalName;
        data["Description"] = this.description;
        data["State"] = this.state;
        data["City"] = this.city;
        data["Address1"] = this.address1;
        data["Address2"] = this.address2;
        data["ZipCode"] = this.zipCode;
        data["Latitude"] = this.latitude;
        data["Longitude"] = this.longitude;
        data["DefaultRate"] = this.defaultRate;
        data["Type"] = this.type;
        data["Status"] = this.status;
        data["ThumbnailImageId"] = this.thumbnailImageId;
        data["PetMax"] = this.petMax;
        data["Bathrooms"] = this.bathrooms;
        data["MinNights"] = this.minNights;
        if (Array.isArray(this.amenities)) {
            data["Amenities"] = [];
            for (let item of this.amenities)
                data["Amenities"].push(item);
        }
        if (Array.isArray(this.policies)) {
            data["Policies"] = [];
            for (let item of this.policies)
                data["Policies"].push(item);
        }
        if (Array.isArray(this.sleepingArrangements)) {
            data["SleepingArrangements"] = [];
            for (let item of this.sleepingArrangements)
                data["SleepingArrangements"].push(item.toJSON());
        }
        data["ShowAddressBeforeDays"] = this.showAddressBeforeDays;
        data["MaxNights"] = this.maxNights;
        data["QuietHoursStartTime"] = this.quietHoursStartTime;
        data["QuietHoursEndTime"] = this.quietHoursEndTime;
        data["QuietHoursEnabled"] = this.quietHoursEnabled;
        data["PartiesAllowed"] = this.partiesAllowed;
        data["SmokingAllowed"] = this.smokingAllowed;
        data["MaxGuests"] = this.maxGuests;
        data["ContactId"] = this.contactId;
        data["HouseRules"] = this.houseRules;
        data["CheckInCheckOutInstructions"] = this.checkInCheckOutInstructions;
        data["IsTest"] = this.isTest;
        return data;
    }

    clone(): PropertyEdit {
        const json = this.toJSON();
        let result = new PropertyEdit();
        result.init(json);
        return result;
    }
}

export interface IPropertyEdit {
    id?: number | undefined;
    name?: string | undefined;
    internalName?: string | undefined;
    description?: string | undefined;
    state?: string | undefined;
    city?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    zipCode?: string | undefined;
    latitude?: number;
    longitude?: number;
    defaultRate?: number;
    type?: PropertyType;
    status?: PropertyStatus;
    thumbnailImageId?: number | undefined;
    petMax?: number;
    bathrooms?: number;
    minNights?: number;
    amenities?: number[] | undefined;
    policies?: number[] | undefined;
    sleepingArrangements?: PropertySleepingArrangement[] | undefined;
    showAddressBeforeDays?: number | undefined;
    maxNights?: number | undefined;
    quietHoursStartTime?: number | undefined;
    quietHoursEndTime?: number | undefined;
    quietHoursEnabled?: boolean;
    partiesAllowed?: boolean;
    smokingAllowed?: boolean;
    maxGuests?: number | undefined;
    contactId?: number;
    houseRules?: string | undefined;
    checkInCheckOutInstructions?: string | undefined;
    isTest?: boolean;
}

/** 1 = CheckInCheckOut */
export enum PropertyAdditionalImageType {
    CheckInCheckOut = 1,
}

/** 0 = Bmp 1 = Gif 2 = Ico 3 = Jpeg 4 = Png 5 = Wbmp 6 = Webp 7 = Pkm 8 = Ktx 9 = Astc 10 = Dng 11 = Heif 12 = Avif */
export enum SKEncodedImageFormat {
    Bmp = 0,
    Gif = 1,
    Ico = 2,
    Jpeg = 3,
    Png = 4,
    Wbmp = 5,
    Webp = 6,
    Pkm = 7,
    Ktx = 8,
    Astc = 9,
    Dng = 10,
    Heif = 11,
    Avif = 12,
}

export class PropertyImage implements IPropertyImage {
    id?: number;
    url?: string | undefined;
    thumbnailUrl?: string | undefined;
    isThumbnail?: boolean;

    constructor(data?: IPropertyImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.url = _data["Url"];
            this.thumbnailUrl = _data["ThumbnailUrl"];
            this.isThumbnail = _data["IsThumbnail"];
        }
    }

    static fromJS(data: any): PropertyImage {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Url"] = this.url;
        data["ThumbnailUrl"] = this.thumbnailUrl;
        data["IsThumbnail"] = this.isThumbnail;
        return data;
    }

    clone(): PropertyImage {
        const json = this.toJSON();
        let result = new PropertyImage();
        result.init(json);
        return result;
    }
}

export interface IPropertyImage {
    id?: number;
    url?: string | undefined;
    thumbnailUrl?: string | undefined;
    isThumbnail?: boolean;
}

export class PropertyAdditionalImage implements IPropertyAdditionalImage {
    id?: number;
    url?: string | undefined;
    type?: PropertyAdditionalImageType;

    constructor(data?: IPropertyAdditionalImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.url = _data["Url"];
            this.type = _data["Type"];
        }
    }

    static fromJS(data: any): PropertyAdditionalImage {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyAdditionalImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Url"] = this.url;
        data["Type"] = this.type;
        return data;
    }

    clone(): PropertyAdditionalImage {
        const json = this.toJSON();
        let result = new PropertyAdditionalImage();
        result.init(json);
        return result;
    }
}

export interface IPropertyAdditionalImage {
    id?: number;
    url?: string | undefined;
    type?: PropertyAdditionalImageType;
}

export class RateListModel implements IRateListModel {
    id?: number;
    name?: string | undefined;
    type?: PropertyRateType;
    rate?: string | undefined;

    constructor(data?: IRateListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.rate = _data["Rate"];
        }
    }

    static fromJS(data: any): RateListModel {
        data = typeof data === 'object' ? data : {};
        let result = new RateListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["Rate"] = this.rate;
        return data;
    }

    clone(): RateListModel {
        const json = this.toJSON();
        let result = new RateListModel();
        result.init(json);
        return result;
    }
}

export interface IRateListModel {
    id?: number;
    name?: string | undefined;
    type?: PropertyRateType;
    rate?: string | undefined;
}

/** 1 = OnSubTotal 2 = Taxes 3 = GuestPerNight 4 = PetPerNight 5 = GeneralPerNight 6 = General 7 = StayDiscount */
export enum PropertyRateType {
    OnSubTotal = 1,
    Taxes = 2,
    GuestPerNight = 3,
    PetPerNight = 4,
    GeneralPerNight = 5,
    General = 6,
    StayDiscount = 7,
}

export class RateEditModel implements IRateEditModel {
    id?: number | undefined;
    name?: string | undefined;
    type?: PropertyRateType;
    rate?: string | undefined;

    constructor(data?: IRateEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.rate = _data["Rate"];
        }
    }

    static fromJS(data: any): RateEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new RateEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["Rate"] = this.rate;
        return data;
    }

    clone(): RateEditModel {
        const json = this.toJSON();
        let result = new RateEditModel();
        result.init(json);
        return result;
    }
}

export interface IRateEditModel {
    id?: number | undefined;
    name?: string | undefined;
    type?: PropertyRateType;
    rate?: string | undefined;
}

export class PropertyRateGeneral implements IPropertyRateGeneral {
    rate?: number;

    constructor(data?: IPropertyRateGeneral) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rate = _data["Rate"];
        }
    }

    static fromJS(data: any): PropertyRateGeneral {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyRateGeneral();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Rate"] = this.rate;
        return data;
    }

    clone(): PropertyRateGeneral {
        const json = this.toJSON();
        let result = new PropertyRateGeneral();
        result.init(json);
        return result;
    }
}

export interface IPropertyRateGeneral {
    rate?: number;
}

export class PropertyRateGeneralPerNight implements IPropertyRateGeneralPerNight {
    rate?: number;

    constructor(data?: IPropertyRateGeneralPerNight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rate = _data["Rate"];
        }
    }

    static fromJS(data: any): PropertyRateGeneralPerNight {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyRateGeneralPerNight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Rate"] = this.rate;
        return data;
    }

    clone(): PropertyRateGeneralPerNight {
        const json = this.toJSON();
        let result = new PropertyRateGeneralPerNight();
        result.init(json);
        return result;
    }
}

export interface IPropertyRateGeneralPerNight {
    rate?: number;
}

export class PropertyRateExtraGuest implements IPropertyRateExtraGuest {
    startFrom?: number;
    isPerNight?: boolean;
    rate?: number;

    constructor(data?: IPropertyRateExtraGuest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startFrom = _data["StartFrom"];
            this.isPerNight = _data["IsPerNight"];
            this.rate = _data["Rate"];
        }
    }

    static fromJS(data: any): PropertyRateExtraGuest {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyRateExtraGuest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartFrom"] = this.startFrom;
        data["IsPerNight"] = this.isPerNight;
        data["Rate"] = this.rate;
        return data;
    }

    clone(): PropertyRateExtraGuest {
        const json = this.toJSON();
        let result = new PropertyRateExtraGuest();
        result.init(json);
        return result;
    }
}

export interface IPropertyRateExtraGuest {
    startFrom?: number;
    isPerNight?: boolean;
    rate?: number;
}

export class PropertyRatePet implements IPropertyRatePet {
    startFrom?: number;
    isPerNight?: boolean;
    rate?: number;

    constructor(data?: IPropertyRatePet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startFrom = _data["StartFrom"];
            this.isPerNight = _data["IsPerNight"];
            this.rate = _data["Rate"];
        }
    }

    static fromJS(data: any): PropertyRatePet {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyRatePet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartFrom"] = this.startFrom;
        data["IsPerNight"] = this.isPerNight;
        data["Rate"] = this.rate;
        return data;
    }

    clone(): PropertyRatePet {
        const json = this.toJSON();
        let result = new PropertyRatePet();
        result.init(json);
        return result;
    }
}

export interface IPropertyRatePet {
    startFrom?: number;
    isPerNight?: boolean;
    rate?: number;
}

export class PropertyRateOnSubTotal implements IPropertyRateOnSubTotal {
    isTaxable?: boolean;
    rate?: number;

    constructor(data?: IPropertyRateOnSubTotal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isTaxable = _data["IsTaxable"];
            this.rate = _data["Rate"];
        }
    }

    static fromJS(data: any): PropertyRateOnSubTotal {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyRateOnSubTotal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsTaxable"] = this.isTaxable;
        data["Rate"] = this.rate;
        return data;
    }

    clone(): PropertyRateOnSubTotal {
        const json = this.toJSON();
        let result = new PropertyRateOnSubTotal();
        result.init(json);
        return result;
    }
}

export interface IPropertyRateOnSubTotal {
    isTaxable?: boolean;
    rate?: number;
}

export class PropertyRateTaxes implements IPropertyRateTaxes {
    rate?: number;

    constructor(data?: IPropertyRateTaxes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rate = _data["Rate"];
        }
    }

    static fromJS(data: any): PropertyRateTaxes {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyRateTaxes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Rate"] = this.rate;
        return data;
    }

    clone(): PropertyRateTaxes {
        const json = this.toJSON();
        let result = new PropertyRateTaxes();
        result.init(json);
        return result;
    }
}

export interface IPropertyRateTaxes {
    rate?: number;
}

export class PropertyRateStayDiscount implements IPropertyRateStayDiscount {
    startFrom?: number;
    rate?: number;

    constructor(data?: IPropertyRateStayDiscount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startFrom = _data["StartFrom"];
            this.rate = _data["Rate"];
        }
    }

    static fromJS(data: any): PropertyRateStayDiscount {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyRateStayDiscount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StartFrom"] = this.startFrom;
        data["Rate"] = this.rate;
        return data;
    }

    clone(): PropertyRateStayDiscount {
        const json = this.toJSON();
        let result = new PropertyRateStayDiscount();
        result.init(json);
        return result;
    }
}

export interface IPropertyRateStayDiscount {
    startFrom?: number;
    rate?: number;
}

export class IntegrationModel implements IIntegrationModel {
    id?: number;
    name?: string;
    type?: IntegrationType;
    settings?: string | undefined;

    constructor(data?: IIntegrationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.type = _data["Type"];
            this.settings = _data["Settings"];
        }
    }

    static fromJS(data: any): IntegrationModel {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["Type"] = this.type;
        data["Settings"] = this.settings;
        return data;
    }

    clone(): IntegrationModel {
        const json = this.toJSON();
        let result = new IntegrationModel();
        result.init(json);
        return result;
    }
}

export interface IIntegrationModel {
    id?: number;
    name?: string;
    type?: IntegrationType;
    settings?: string | undefined;
}

export class ListingListModel implements IListingListModel {
    id?: number;
    name?: string | undefined;
    internalListingName?: string | undefined;

    constructor(data?: IListingListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.name = _data["Name"];
            this.internalListingName = _data["InternalListingName"];
        }
    }

    static fromJS(data: any): ListingListModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListingListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Name"] = this.name;
        data["InternalListingName"] = this.internalListingName;
        return data;
    }

    clone(): ListingListModel {
        const json = this.toJSON();
        let result = new ListingListModel();
        result.init(json);
        return result;
    }
}

export interface IListingListModel {
    id?: number;
    name?: string | undefined;
    internalListingName?: string | undefined;
}

export class PropertyIntegrationModel implements IPropertyIntegrationModel {
    integrationId?: number;
    settings?: string | undefined;
    externalId?: string | undefined;

    constructor(data?: IPropertyIntegrationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.integrationId = _data["IntegrationId"];
            this.settings = _data["Settings"];
            this.externalId = _data["ExternalId"];
        }
    }

    static fromJS(data: any): PropertyIntegrationModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyIntegrationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IntegrationId"] = this.integrationId;
        data["Settings"] = this.settings;
        data["ExternalId"] = this.externalId;
        return data;
    }

    clone(): PropertyIntegrationModel {
        const json = this.toJSON();
        let result = new PropertyIntegrationModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyIntegrationModel {
    integrationId?: number;
    settings?: string | undefined;
    externalId?: string | undefined;
}

export class DataListResultOfPropertyInventoryListModel implements IDataListResultOfPropertyInventoryListModel {
    items?: PropertyInventoryListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfPropertyInventoryListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(PropertyInventoryListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfPropertyInventoryListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfPropertyInventoryListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfPropertyInventoryListModel {
        const json = this.toJSON();
        let result = new DataListResultOfPropertyInventoryListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfPropertyInventoryListModel {
    items?: PropertyInventoryListModel[] | undefined;
    count?: number;
}

export class PropertyInventoryListModel implements IPropertyInventoryListModel {
    id?: number;
    requiredQty?: number;
    actualQty?: number;
    replaceOn?: moment.Moment | undefined;
    createdAt?: moment.Moment;
    propertyName?: string | undefined;
    propertyId?: number;
    propertyUnit?: string | undefined;
    propertyUnitId?: number | undefined;
    category?: string | undefined;
    inventoryName?: string | undefined;
    inventoryAssignmentName?: string | undefined;
    inventoryAssignmentId?: number | undefined;
    overridden?: boolean;

    constructor(data?: IPropertyInventoryListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.requiredQty = _data["RequiredQty"];
            this.actualQty = _data["ActualQty"];
            this.replaceOn = _data["ReplaceOn"] ? moment(_data["ReplaceOn"].toString()) : <any>undefined;
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.propertyName = _data["PropertyName"];
            this.propertyId = _data["PropertyId"];
            this.propertyUnit = _data["PropertyUnit"];
            this.propertyUnitId = _data["PropertyUnitId"];
            this.category = _data["Category"];
            this.inventoryName = _data["InventoryName"];
            this.inventoryAssignmentName = _data["InventoryAssignmentName"];
            this.inventoryAssignmentId = _data["InventoryAssignmentId"];
            this.overridden = _data["Overridden"];
        }
    }

    static fromJS(data: any): PropertyInventoryListModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyInventoryListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["RequiredQty"] = this.requiredQty;
        data["ActualQty"] = this.actualQty;
        data["ReplaceOn"] = this.replaceOn ? this.replaceOn.toISOString() : <any>undefined;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["PropertyName"] = this.propertyName;
        data["PropertyId"] = this.propertyId;
        data["PropertyUnit"] = this.propertyUnit;
        data["PropertyUnitId"] = this.propertyUnitId;
        data["Category"] = this.category;
        data["InventoryName"] = this.inventoryName;
        data["InventoryAssignmentName"] = this.inventoryAssignmentName;
        data["InventoryAssignmentId"] = this.inventoryAssignmentId;
        data["Overridden"] = this.overridden;
        return data;
    }

    clone(): PropertyInventoryListModel {
        const json = this.toJSON();
        let result = new PropertyInventoryListModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyInventoryListModel {
    id?: number;
    requiredQty?: number;
    actualQty?: number;
    replaceOn?: moment.Moment | undefined;
    createdAt?: moment.Moment;
    propertyName?: string | undefined;
    propertyId?: number;
    propertyUnit?: string | undefined;
    propertyUnitId?: number | undefined;
    category?: string | undefined;
    inventoryName?: string | undefined;
    inventoryAssignmentName?: string | undefined;
    inventoryAssignmentId?: number | undefined;
    overridden?: boolean;
}

export class DataListGetParamsOfPropertyInventoryListFilters implements IDataListGetParamsOfPropertyInventoryListFilters {
    filter?: PropertyInventoryListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfPropertyInventoryListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? PropertyInventoryListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfPropertyInventoryListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfPropertyInventoryListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfPropertyInventoryListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfPropertyInventoryListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfPropertyInventoryListFilters {
    filter?: PropertyInventoryListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class PropertyInventoryListFilters implements IPropertyInventoryListFilters {
    search?: string | undefined;
    propertyId?: number | undefined;

    constructor(data?: IPropertyInventoryListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
            this.propertyId = _data["PropertyId"];
        }
    }

    static fromJS(data: any): PropertyInventoryListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyInventoryListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        data["PropertyId"] = this.propertyId;
        return data;
    }

    clone(): PropertyInventoryListFilters {
        const json = this.toJSON();
        let result = new PropertyInventoryListFilters();
        result.init(json);
        return result;
    }
}

export interface IPropertyInventoryListFilters {
    search?: string | undefined;
    propertyId?: number | undefined;
}

export class PropertyInventoryUpdatedRequiredQtyModel implements IPropertyInventoryUpdatedRequiredQtyModel {
    requiredQty?: number;
    id?: number;

    constructor(data?: IPropertyInventoryUpdatedRequiredQtyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requiredQty = _data["RequiredQty"];
            this.id = _data["Id"];
        }
    }

    static fromJS(data: any): PropertyInventoryUpdatedRequiredQtyModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyInventoryUpdatedRequiredQtyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["RequiredQty"] = this.requiredQty;
        data["Id"] = this.id;
        return data;
    }

    clone(): PropertyInventoryUpdatedRequiredQtyModel {
        const json = this.toJSON();
        let result = new PropertyInventoryUpdatedRequiredQtyModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyInventoryUpdatedRequiredQtyModel {
    requiredQty?: number;
    id?: number;
}

export class PropertyInventoryResetRequiredQtyModel implements IPropertyInventoryResetRequiredQtyModel {
    id?: number;

    constructor(data?: IPropertyInventoryResetRequiredQtyModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
        }
    }

    static fromJS(data: any): PropertyInventoryResetRequiredQtyModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyInventoryResetRequiredQtyModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        return data;
    }

    clone(): PropertyInventoryResetRequiredQtyModel {
        const json = this.toJSON();
        let result = new PropertyInventoryResetRequiredQtyModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyInventoryResetRequiredQtyModel {
    id?: number;
}

export class PropertyInventoryUpdateStockModel implements IPropertyInventoryUpdateStockModel {
    id?: number;
    changeQty?: number;
    notes?: string | undefined;

    constructor(data?: IPropertyInventoryUpdateStockModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.changeQty = _data["ChangeQty"];
            this.notes = _data["Notes"];
        }
    }

    static fromJS(data: any): PropertyInventoryUpdateStockModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyInventoryUpdateStockModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ChangeQty"] = this.changeQty;
        data["Notes"] = this.notes;
        return data;
    }

    clone(): PropertyInventoryUpdateStockModel {
        const json = this.toJSON();
        let result = new PropertyInventoryUpdateStockModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyInventoryUpdateStockModel {
    id?: number;
    changeQty?: number;
    notes?: string | undefined;
}

export class PropertyInventoryStocktaking implements IPropertyInventoryStocktaking {
    id?: number;
    actualQty?: number;
    refillQty?: number;

    constructor(data?: IPropertyInventoryStocktaking) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.actualQty = _data["ActualQty"];
            this.refillQty = _data["RefillQty"];
        }
    }

    static fromJS(data: any): PropertyInventoryStocktaking {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyInventoryStocktaking();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["ActualQty"] = this.actualQty;
        data["RefillQty"] = this.refillQty;
        return data;
    }

    clone(): PropertyInventoryStocktaking {
        const json = this.toJSON();
        let result = new PropertyInventoryStocktaking();
        result.init(json);
        return result;
    }
}

export interface IPropertyInventoryStocktaking {
    id?: number;
    actualQty?: number;
    refillQty?: number;
}

export abstract class PropertyInventoryBaseModel implements IPropertyInventoryBaseModel {
    replaceOn?: moment.Moment | undefined;

    constructor(data?: IPropertyInventoryBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.replaceOn = _data["ReplaceOn"] ? moment(_data["ReplaceOn"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PropertyInventoryBaseModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PropertyInventoryBaseModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ReplaceOn"] = this.replaceOn ? this.replaceOn.toISOString() : <any>undefined;
        return data;
    }

    clone(): PropertyInventoryBaseModel {
        throw new Error("The abstract class 'PropertyInventoryBaseModel' cannot be instantiated.");
    }
}

export interface IPropertyInventoryBaseModel {
    replaceOn?: moment.Moment | undefined;
}

export class PropertyInventoryNewModel extends PropertyInventoryBaseModel implements IPropertyInventoryNewModel {
    propertyId?: number;
    propertyUnitId?: number | undefined;
    inventoryAssignmentId?: number;

    constructor(data?: IPropertyInventoryNewModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.propertyId = _data["PropertyId"];
            this.propertyUnitId = _data["PropertyUnitId"];
            this.inventoryAssignmentId = _data["InventoryAssignmentId"];
        }
    }

    static override fromJS(data: any): PropertyInventoryNewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyInventoryNewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PropertyId"] = this.propertyId;
        data["PropertyUnitId"] = this.propertyUnitId;
        data["InventoryAssignmentId"] = this.inventoryAssignmentId;
        super.toJSON(data);
        return data;
    }

    clone(): PropertyInventoryNewModel {
        const json = this.toJSON();
        let result = new PropertyInventoryNewModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyInventoryNewModel extends IPropertyInventoryBaseModel {
    propertyId?: number;
    propertyUnitId?: number | undefined;
    inventoryAssignmentId?: number;
}

export class PropertyInventoryAddAllModel extends PropertyInventoryBaseModel implements IPropertyInventoryAddAllModel {
    propertyId?: number;
    propertyUnitId?: number | undefined;

    constructor(data?: IPropertyInventoryAddAllModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.propertyId = _data["PropertyId"];
            this.propertyUnitId = _data["PropertyUnitId"];
        }
    }

    static override fromJS(data: any): PropertyInventoryAddAllModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyInventoryAddAllModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["PropertyId"] = this.propertyId;
        data["PropertyUnitId"] = this.propertyUnitId;
        super.toJSON(data);
        return data;
    }

    clone(): PropertyInventoryAddAllModel {
        const json = this.toJSON();
        let result = new PropertyInventoryAddAllModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyInventoryAddAllModel extends IPropertyInventoryBaseModel {
    propertyId?: number;
    propertyUnitId?: number | undefined;
}

export class PropertyInventoryAddAssignmentModel extends PropertyInventoryBaseModel implements IPropertyInventoryAddAssignmentModel {
    inventoryAssignmentId?: number;

    constructor(data?: IPropertyInventoryAddAssignmentModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.inventoryAssignmentId = _data["InventoryAssignmentId"];
        }
    }

    static override fromJS(data: any): PropertyInventoryAddAssignmentModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyInventoryAddAssignmentModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["InventoryAssignmentId"] = this.inventoryAssignmentId;
        super.toJSON(data);
        return data;
    }

    clone(): PropertyInventoryAddAssignmentModel {
        const json = this.toJSON();
        let result = new PropertyInventoryAddAssignmentModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyInventoryAddAssignmentModel extends IPropertyInventoryBaseModel {
    inventoryAssignmentId?: number;
}

export class PropertyInventoryDetailsModel implements IPropertyInventoryDetailsModel {
    id?: number;
    requiredQty?: number;
    actualQty?: number;
    replaceOn?: moment.Moment | undefined;
    assignmentName?: string | undefined;
    assignmentId?: number;
    category?: InventoryItemCategoryType;

    constructor(data?: IPropertyInventoryDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.requiredQty = _data["RequiredQty"];
            this.actualQty = _data["ActualQty"];
            this.replaceOn = _data["ReplaceOn"] ? moment(_data["ReplaceOn"].toString()) : <any>undefined;
            this.assignmentName = _data["AssignmentName"];
            this.assignmentId = _data["AssignmentId"];
            this.category = _data["Category"];
        }
    }

    static fromJS(data: any): PropertyInventoryDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyInventoryDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["RequiredQty"] = this.requiredQty;
        data["ActualQty"] = this.actualQty;
        data["ReplaceOn"] = this.replaceOn ? this.replaceOn.toISOString() : <any>undefined;
        data["AssignmentName"] = this.assignmentName;
        data["AssignmentId"] = this.assignmentId;
        data["Category"] = this.category;
        return data;
    }

    clone(): PropertyInventoryDetailsModel {
        const json = this.toJSON();
        let result = new PropertyInventoryDetailsModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyInventoryDetailsModel {
    id?: number;
    requiredQty?: number;
    actualQty?: number;
    replaceOn?: moment.Moment | undefined;
    assignmentName?: string | undefined;
    assignmentId?: number;
    category?: InventoryItemCategoryType;
}

export class PropertyPromoCodeEditModel implements IPropertyPromoCodeEditModel {
    amount?: number;
    expiredAt?: moment.Moment;
    promoCode?: string | undefined;
    minNights?: number;
    propertyId?: number;
    assignedToUserId?: string | undefined;

    constructor(data?: IPropertyPromoCodeEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["Amount"];
            this.expiredAt = _data["ExpiredAt"] ? moment(_data["ExpiredAt"].toString()) : <any>undefined;
            this.promoCode = _data["PromoCode"];
            this.minNights = _data["MinNights"];
            this.propertyId = _data["PropertyId"];
            this.assignedToUserId = _data["AssignedToUserId"];
        }
    }

    static fromJS(data: any): PropertyPromoCodeEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyPromoCodeEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Amount"] = this.amount;
        data["ExpiredAt"] = this.expiredAt ? this.expiredAt.toISOString() : <any>undefined;
        data["PromoCode"] = this.promoCode;
        data["MinNights"] = this.minNights;
        data["PropertyId"] = this.propertyId;
        data["AssignedToUserId"] = this.assignedToUserId;
        return data;
    }

    clone(): PropertyPromoCodeEditModel {
        const json = this.toJSON();
        let result = new PropertyPromoCodeEditModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyPromoCodeEditModel {
    amount?: number;
    expiredAt?: moment.Moment;
    promoCode?: string | undefined;
    minNights?: number;
    propertyId?: number;
    assignedToUserId?: string | undefined;
}

export class DataListResultOfPropertyPromoCodeListModel implements IDataListResultOfPropertyPromoCodeListModel {
    items?: PropertyPromoCodeListModel[] | undefined;
    count?: number;

    constructor(data?: IDataListResultOfPropertyPromoCodeListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(PropertyPromoCodeListModel.fromJS(item));
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataListResultOfPropertyPromoCodeListModel {
        data = typeof data === 'object' ? data : {};
        let result = new DataListResultOfPropertyPromoCodeListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item.toJSON());
        }
        data["Count"] = this.count;
        return data;
    }

    clone(): DataListResultOfPropertyPromoCodeListModel {
        const json = this.toJSON();
        let result = new DataListResultOfPropertyPromoCodeListModel();
        result.init(json);
        return result;
    }
}

export interface IDataListResultOfPropertyPromoCodeListModel {
    items?: PropertyPromoCodeListModel[] | undefined;
    count?: number;
}

export class PropertyPromoCodeListModel implements IPropertyPromoCodeListModel {
    id?: number;
    property?: string | undefined;
    promoCode?: string | undefined;
    active?: boolean;
    expiredAt?: moment.Moment;
    amount?: number;
    createdAt?: moment.Moment;
    createdBy?: string | undefined;
    propertyReservationId?: number | undefined;
    appliedAt?: moment.Moment | undefined;

    constructor(data?: IPropertyPromoCodeListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["Id"];
            this.property = _data["Property"];
            this.promoCode = _data["PromoCode"];
            this.active = _data["Active"];
            this.expiredAt = _data["ExpiredAt"] ? moment(_data["ExpiredAt"].toString()) : <any>undefined;
            this.amount = _data["Amount"];
            this.createdAt = _data["CreatedAt"] ? moment(_data["CreatedAt"].toString()) : <any>undefined;
            this.createdBy = _data["CreatedBy"];
            this.propertyReservationId = _data["PropertyReservationId"];
            this.appliedAt = _data["AppliedAt"] ? moment(_data["AppliedAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PropertyPromoCodeListModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyPromoCodeListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Id"] = this.id;
        data["Property"] = this.property;
        data["PromoCode"] = this.promoCode;
        data["Active"] = this.active;
        data["ExpiredAt"] = this.expiredAt ? this.expiredAt.toISOString() : <any>undefined;
        data["Amount"] = this.amount;
        data["CreatedAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["CreatedBy"] = this.createdBy;
        data["PropertyReservationId"] = this.propertyReservationId;
        data["AppliedAt"] = this.appliedAt ? this.appliedAt.toISOString() : <any>undefined;
        return data;
    }

    clone(): PropertyPromoCodeListModel {
        const json = this.toJSON();
        let result = new PropertyPromoCodeListModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyPromoCodeListModel {
    id?: number;
    property?: string | undefined;
    promoCode?: string | undefined;
    active?: boolean;
    expiredAt?: moment.Moment;
    amount?: number;
    createdAt?: moment.Moment;
    createdBy?: string | undefined;
    propertyReservationId?: number | undefined;
    appliedAt?: moment.Moment | undefined;
}

export class DataListGetParamsOfPropertyPromoCodeListFilters implements IDataListGetParamsOfPropertyPromoCodeListFilters {
    filter?: PropertyPromoCodeListFilters | undefined;
    pageSize?: number;
    offset?: number;

    constructor(data?: IDataListGetParamsOfPropertyPromoCodeListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["Filter"] ? PropertyPromoCodeListFilters.fromJS(_data["Filter"]) : <any>undefined;
            this.pageSize = _data["PageSize"];
            this.offset = _data["Offset"];
        }
    }

    static fromJS(data: any): DataListGetParamsOfPropertyPromoCodeListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new DataListGetParamsOfPropertyPromoCodeListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["PageSize"] = this.pageSize;
        data["Offset"] = this.offset;
        return data;
    }

    clone(): DataListGetParamsOfPropertyPromoCodeListFilters {
        const json = this.toJSON();
        let result = new DataListGetParamsOfPropertyPromoCodeListFilters();
        result.init(json);
        return result;
    }
}

export interface IDataListGetParamsOfPropertyPromoCodeListFilters {
    filter?: PropertyPromoCodeListFilters | undefined;
    pageSize?: number;
    offset?: number;
}

export class PropertyPromoCodeListFilters implements IPropertyPromoCodeListFilters {
    search?: string | undefined;

    constructor(data?: IPropertyPromoCodeListFilters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.search = _data["Search"];
        }
    }

    static fromJS(data: any): PropertyPromoCodeListFilters {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyPromoCodeListFilters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Search"] = this.search;
        return data;
    }

    clone(): PropertyPromoCodeListFilters {
        const json = this.toJSON();
        let result = new PropertyPromoCodeListFilters();
        result.init(json);
        return result;
    }
}

export interface IPropertyPromoCodeListFilters {
    search?: string | undefined;
}

export class PropertyPromoCodeModel extends PropertyPromoCodeEditModel implements IPropertyPromoCodeModel {
    active?: boolean;
    property?: string | undefined;
    assignedToUser?: string | undefined;
    propertyReservationId?: number | undefined;

    constructor(data?: IPropertyPromoCodeModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.active = _data["Active"];
            this.property = _data["Property"];
            this.assignedToUser = _data["AssignedToUser"];
            this.propertyReservationId = _data["PropertyReservationId"];
        }
    }

    static override fromJS(data: any): PropertyPromoCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyPromoCodeModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Active"] = this.active;
        data["Property"] = this.property;
        data["AssignedToUser"] = this.assignedToUser;
        data["PropertyReservationId"] = this.propertyReservationId;
        super.toJSON(data);
        return data;
    }

    clone(): PropertyPromoCodeModel {
        const json = this.toJSON();
        let result = new PropertyPromoCodeModel();
        result.init(json);
        return result;
    }
}

export interface IPropertyPromoCodeModel extends IPropertyPromoCodeEditModel {
    active?: boolean;
    property?: string | undefined;
    assignedToUser?: string | undefined;
    propertyReservationId?: number | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class CodedExceptionApi extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isCodedExceptionApi = true;

    static isCodedExceptionApi(obj: any): obj is CodedExceptionApi {
        return obj.isCodedExceptionApi === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new CodedExceptionApi(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}